// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { 
  getAuth, 
  onAuthStateChanged, 
  signOut, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  updateProfile,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithCredential
} from "firebase/auth";
import { doc, getDoc, getFirestore, setDoc, getDocs, collection, updateDoc, deleteField, onSnapshot, deleteDoc, query, where} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll,
} from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getDatabase, ref as refDatabase, onValue, set, onDisconnect, remove, push, get } from "firebase/database";
import { toast } from "react-hot-toast";
import Swal from 'sweetalert2';
import { deleteDB, openDB } from 'idb';
import { datosAdmin } from "./administrador";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const firebaseConfigRankingPws = {
  apiKey: process.env.REACT_APP_RANKINGPWS_API_KEY,
  authDomain: process.env.REACT_APP_RANKINGPWS_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_RANKINGPWS_PROJECT_ID,
  storageBucket: process.env.REACT_APP_RANKINGPWS_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_RANKINGPWS_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_RANKINGPWS_APP_ID,
  measurementId: process.env.REACT_APP_RANKINGPWS_MEASUREMENT_ID
};

const firebaseConfigFamilia = {
  apiKey: process.env.REACT_APP_RESULTFAMILIAS_API_KEY,
  authDomain: process.env.REACT_APP_RESULTFAMILIAS_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_RESULTFAMILIAS_PROJECT_ID,
  storageBucket: process.env.REACT_APP_RESULTFAMILIAS_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_RESULTFAMILIAS_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_RESULTFAMILIAS_APP_ID,
  measurementId: process.env.REACT_APP_RESULTFAMILIAS_MEASUREMENT_ID
};

// Initialize Firebase
const db = initializeApp(firebaseConfig);
const firestore = getFirestore(db);
const storage = getStorage();
const database = getDatabase();
const analytics= getAnalytics(db);

//Initialize Firebase Ranking Prowebsports
const dbRankingPws = initializeApp(firebaseConfigRankingPws, 'db2');
const firestoreRankingPws = getFirestore(dbRankingPws);
const auth = getAuth(dbRankingPws);
const storagePws = getStorage(dbRankingPws);
const messaging = getMessaging(dbRankingPws);
const analyticsRankingPws = getAnalytics(dbRankingPws);

//Initialize Firebase resultados para familiares y demas Prowebsports
const dbFamilia = initializeApp(firebaseConfigFamilia, 'db3');
const firestoreFamilia = getFirestore(dbFamilia);
const authFamilia = getAuth(dbFamilia);
const databaseFamilia = getDatabase(dbFamilia);
const analyticsFamilia = getAnalytics(dbFamilia);
const providerGoogle = new GoogleAuthProvider();

//Con esta funcion vamos a saber los cambios en la sesión.
let contadorEquipo = 0;
export function sesionIniciada(setUsuario){
  onAuthStateChanged(auth, (usuarioFirebase) => {
    let datosUsuario = {};
    if(usuarioFirebase){
      datosUsuario = {
        nombreclub: auth.currentUser.displayName,
        id: usuarioFirebase ? usuarioFirebase.uid : "",
        photo: auth.currentUser.photoURL,
        email: auth.currentUser.email,
        conexion: false,
        directivos: []
      }

      let autorizado = false;
      traerClubesAutorizados().then((auto)=>{
        traerUsuariosPws(datosUsuario).then((info)=>{
          const buscarExistenciaAutorizado = auto.filter((autoriza) => {return autoriza.nombre === datosUsuario.nombreclub});
          if(info){
            if(buscarExistenciaAutorizado.length === 0){
              registrarNombreAutorizado([...auto, {
                abreviatura: info.abreviatura,
                autorizado: true,
                departamento: info.departamento,
                nombre: info.nombreclub,
                codePais: info.codePais
              }]);

              auto.push({
                abreviatura: info.abreviatura,
                autorizado: true,
                departamento: info.departamento,
                nombre: info.nombreclub,
                codePais: info.codePais
              });
            }

            if(info.directivos){
              datosUsuario.directivos = info.directivos.sort((a, b) => a.id - b.id);
            }

          }else{
            if(buscarExistenciaAutorizado.length !== 0){
              autorizado = true;
              datosUsuario.abreviatura = buscarExistenciaAutorizado[0].abreviatura;
              datosUsuario.departamento = buscarExistenciaAutorizado[0].departamento;
              datosUsuario.codePais = buscarExistenciaAutorizado[0].codePais;
              registrarUsuarioPws(datosUsuario);
            }
          }
          
          auto.forEach((autoriza)=>{
            if(autoriza.nombre === datosUsuario.nombreclub && autoriza.autorizado){
              autorizado = true;
              datosUsuario.abreviatura = autoriza.abreviatura;
              datosUsuario.departamento = autoriza.departamento;
              datosUsuario.codePais = autoriza.codePais;
            }
          })

          if(autorizado){
            eliminarClubDelListado(datosUsuario.nombreclub);
            if(datosUsuario.nombreclub === datosAdmin.nombre){
              validarActivacionPlataforma(datosAdmin.conexion).then((activada)=>{
                if(!activada){
                  cerrarSesion();
                  const alerta = Swal.mixin({
                    toast: true,
                    timer: '15000',
                    timerProgressBar: true,
                    showConfirmButton: false
                  })
                  alerta.fire({
                    html: `<div class="w-100 position-relative">
                    <img style="width: 100px; position: absolute; top: 13px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
                    <p style="z-index: 10; font-family: Poppins" class="mb-0">Esta cuenta ha sido inhabilitada. </br> Por favor,
                    comuniquese </br> con el equipo de </br> PROWEBSPORTS.
                    </div>`,
                    position: 'top-end',
                    padding: 2
                  })
                }
              })
            }
            if(contadorEquipo === 0){
              requestNotificationPermission(datosUsuario);
              contadorEquipo++
            }
            setUsuario(datosUsuario);
          }else{
            cerrarSesion();
            const alerta = Swal.mixin({
              toast: true,
            })
            alerta.fire({
              html: `<div class="w-100 position-relative">
              <img style="width: 100px; position: absolute; top: 33px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
              <p style="z-index: 10; font-family: Poppins" class="mb-0">No tienes autorización para <br/> ingresar a la plataforma. <br/>
              Comuniquese con el <br/> Club de Natación ${datosAdmin.nombre}.</p>
              </div>`,
              confirmButtonText: 'Entendido',
              confirmButtonColor: 'rgb(18, 53, 248)',
              position: 'top-end',
              padding: 2
            })
          }
        })
      })
    }else{
      setUsuario();
    }
  });
}

// Función para registrar un usuario
export async function registrarUsuario(email, password, nombre) {
  try {
    await createUserWithEmailAndPassword(auth, email, password).then(
      (usuarioFirebase) => {
        return usuarioFirebase;
      }
    );

    updateProfile(auth.currentUser, {
      displayName: nombre
    }).catch(() => {
      toast.error("Ocurrió un error al registrar su nombre.");
    });

    if (auth.currentUser && !auth.currentUser.emailVerified) {
      cerrarSesion();
    }
  } catch (err) {
    toast.error("El correo electrónico  " + email + ", ya está registrado.");
  }
}

//Funcion para ingresar a la plataforma.
export async function login(email, password){
  signInWithEmailAndPassword(auth, email, password)
    .then(() => {
      if (auth.currentUser && !auth.currentUser.emailVerified) {
        cerrarSesion();
        const alerta = Swal.mixin({
          toast: true,
          timer: '8000',
          timerProgressBar: true,
          showConfirmButton: false
        })
        alerta.fire({
          html: `<div class="w-100 position-relative">
          <img style="width: 100px; position: absolute; top: 23px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
          <p style="z-index: 10; font-family: Poppins" class="mb-0">Aparentemente no ha verificado </br> su correo electrónico, </br> verifique el correo </br> electrónico ${email}.
          </div>`,
          position: 'top-end',
          padding: 2
        })
      }
    })
    .catch((err) => {
      if(err.code === 'auth/wrong-password'){
        toast.error("Contraseña incorrecta. Por favor, intentalo de nuevo.");
      }
      if(err.code === 'auth/user-not-found'){
        toast.error("¡UPS! el correo " + email + ", no esta registrado aún.");
      }
      if(err.code === 'auth/user-disabled'){
        toast.error("Lo sentimos, pero esta cuenta ha sido inhabilitada, comunicate con el equipo de PROWEBSPORTS.");
      }
      if(err.code === 'auth/network-request-failed'){
        toast.error('Sin conexion a internet');
      }
      if(err.code === 'auth/invalid-login-credentials'){
        toast.error('Correo y/o Contraseña incorrecta.');
      }
    });
}

//Funcion para cerrar sesión.
export function cerrarSesion(){
  signOut(auth);
}

let unsubscribeConsolidado = null;

/*operaciones para el consolidado
*/
export function consolidado(idTorneo, setClubes){
  if(idTorneo !== ''){
    const clubesRef = collection(firestore, `TorneosTemporales/${idTorneo}/clubes`);
    unsubscribeConsolidado = onSnapshot(clubesRef, (snapshot) => {
      const consolidado = [];
  
      snapshot.forEach((doc) => {
        consolidado.push(doc.data());
      });
      setClubes(consolidado);
    });
  }
}

// Función para cancelar la suscripción
export function cancelarSuscripcionConsolidado() {
  if (unsubscribeConsolidado) {
    unsubscribeConsolidado();
    unsubscribeConsolidado = null;
  }
}

//funcion para sacar conteo de medallas oro, plata y bronce
export function sacarMedalleriaTrofeoClub(resultados, categoriasElegidas, puntuar){
  const trofeoClub = {};

  resultados.forEach((data) => {
    if (data.nadadores) {
      const categoria = data.categoria;
      // Verificar si la categoría está en el rango requerido
      const condicionCate = categoriasElegidas.length !== 0 ? categoriasElegidas.includes(categoria) : categoria.includes('');
      if (condicionCate){
        const nadadores = data.nadadores.filter(
          (nadador) => nadador.tiempo !== "0:0:0" && nadador.tiempo !== "61:0:0"
        );

        if(data.nadadores.length !== 1 || (data.nadadores.length === 1 && puntuar === 'si')){
          nadadores.forEach((nadador) => {
            if (!trofeoClub[nadador.nombreclub]) {
              trofeoClub[nadador.nombreclub] = {
                departamento: nadador.departamento,
                codePais: nadador.codePais,
                oro: 0,
                plata: 0,
                bronce: 0,
                total: 0,
              };
            }
            if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.nombreclub].oro++;
            } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.nombreclub].plata++;
            } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.nombreclub].bronce++;
            }
            trofeoClub[nadador.nombreclub].total++;
          });
        }
      }
    }
  });
  // Calcular el total de medallas por club
  Object.values(trofeoClub).forEach((club) => {
    club.total = club.oro + club.plata + club.bronce;
  });
  const auxTrofeoClub = Object.entries(trofeoClub)
    .map(([club, values]) => ({
      club,
      ...values,
    }))
    .sort((a, b) => {
      if (b.oro !== a.oro) {
        return b.oro - a.oro; // Ordenar por medallas de oro de manera descendente
      } else if (b.plata !== a.plata) {
        return b.plata - a.plata; // Ordenar por medallas de plata de manera descendente
      } else {
        return b.bronce - a.bronce; // Ordenar por medallas de bronce de manera descendente
      }
    });
  return auxTrofeoClub;
}

export function sacarMedalleriaTrofeoDepartamento(resultados, categoriasElegidas, puntuar){
  const trofeoClub = {};

  resultados.forEach((data) => {
    if (data.nadadores) {
      const categoria = data.categoria;
      // Verificar si la categoría está en el rango requerido
      const condicionCate = categoriasElegidas.length !== 0 ? categoriasElegidas.includes(categoria) : categoria.includes('');
      if (condicionCate){
        const nadadores = data.nadadores.filter(
          (nadador) => nadador.tiempo !== "0:0:0" && nadador.tiempo !== "61:0:0"
        );
        if(data.nadadores.length !== 1 || (data.nadadores.length === 1 && puntuar === 'si')){ 
          nadadores.forEach((nadador) => {
            if (!trofeoClub[nadador.departamento]) {
              trofeoClub[nadador.departamento] = {
                departamento: nadador.departamento,
                codePais: nadador.codePais,
                oro: 0,
                plata: 0,
                bronce: 0,
                total: 0,
              };
            }
            if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.departamento].oro++;
            } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.departamento].plata++;
            } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
              trofeoClub[nadador.departamento].bronce++;
            }
            trofeoClub[nadador.departamento].total++;
          });
        }
      }
    }
  });
  // Calcular el total de medallas por club
  Object.values(trofeoClub).forEach((club) => {
    club.total = club.oro + club.plata + club.bronce;
  });
  const auxTrofeoClub = Object.entries(trofeoClub)
    .map(([club, values]) => ({
      club,
      ...values,
    }))
    .sort((a, b) => {
      if (b.oro !== a.oro) {
        return b.oro - a.oro; // Ordenar por medallas de oro de manera descendente
      } else if (b.plata !== a.plata) {
        return b.plata - a.plata; // Ordenar por medallas de plata de manera descendente
      } else {
        return b.bronce - a.bronce; // Ordenar por medallas de bronce de manera descendente
      }
    });
  return auxTrofeoClub;
}

export function sacarMedalleriaDeportistas(resultados, categoriasElegidas){
  const trofeoClub = {};

  resultados.forEach((data) => {
    if (data.nadadores) {
      const categoria = data.categoria;
      // Verificar si la categoría está en el rango requerido
      const condicionCate = categoriasElegidas.length !== 0 ? categoriasElegidas.includes(categoria) : categoria.includes('');
      if (condicionCate) {
        const nadadores = data.nadadores.filter(
          (nadador) => nadador.tiempo !== "0:0:0" && nadador.tiempo !== "61:0:0"
        );
        nadadores.forEach((nadador) => {
          if (!trofeoClub[nadador.nombre]) {
            trofeoClub[nadador.nombre] = {
              club: nadador.nombreclub,
              categoria,
              oro: 0,
              plata: 0,
              bronce: 0,
              total: 0,
            };
          }
          if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
            trofeoClub[nadador.nombre].oro++;
          } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
            trofeoClub[nadador.nombre].plata++;
          } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
            trofeoClub[nadador.nombre].bronce++;
          }
          trofeoClub[nadador.nombre].total++;
        });
      }
    }
  });
  // Calcular el total de medallas por club
  Object.values(trofeoClub).forEach((club) => {
    club.total = club.oro + club.plata + club.bronce;
  });
  const auxTrofeoClub = Object.entries(trofeoClub)
    .map(([deportista, values]) => ({
      deportista,
      ...values,
    }))
    .sort((a, b) => {
      if (b.oro !== a.oro) {
        return b.oro - a.oro; // Ordenar por medallas de oro de manera descendente
      } else if (b.plata !== a.plata) {
        return b.plata - a.plata; // Ordenar por medallas de plata de manera descendente
      } else {
        return b.bronce - a.bronce; // Ordenar por medallas de bronce de manera descendente
      }
    });
  return auxTrofeoClub;
}

function puntos8Carriles(trofeoClub, nadadores){
  nadadores.forEach((nadador) => {
    if (!trofeoClub[nadador.nombreclub]) {
      trofeoClub[nadador.nombreclub] = {
        departamento: nadador.departamento,
        codePais: nadador.codePais,
        punto1: 0,
        punto2: 0,
        punto3: 0,
        punto4: 0,
        punto5: 0,
        punto6: 0,
        punto7: 0,
        punto8: 0,
        punto9: 0,
        punto10: 0,
        punto11: 0,
        punto12: 0,
        punto13: 0,
        punto14: 0,
        punto15: 0,
        punto16: 0,
        total: 0,
      };
    }
    if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto1+=18;
    } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto2+=16;
    } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto3+=15;
    } else if (nadador.posicion === 4 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto4+=14;
    } else if (nadador.posicion === 5 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto5+=13;
    } else if (nadador.posicion === 6 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto6+=12;
    } else if (nadador.posicion === 7 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto7+=11;
    } else if (nadador.posicion === 8 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto8+=10;
    } else if (nadador.posicion === 9 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto9+=8;
    } else if (nadador.posicion === 10 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto10+=7;
    } else if (nadador.posicion === 11 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto11+=6;
    } else if (nadador.posicion === 12 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto12+=5;
    } else if (nadador.posicion === 13 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto13+=4;
    } else if (nadador.posicion === 14 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto14+=3;
    } else if (nadador.posicion === 15 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto15+=2;
    } else if (nadador.posicion === 16 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto16+=1;
    }
    trofeoClub[nadador.nombreclub].total++;       
  });
}

function puntosRelevo8Carriles(trofeoClub, nadadores){
  nadadores.forEach((nadador) => {
    if (!trofeoClub[nadador.nombreclub]) {
      trofeoClub[nadador.nombreclub] = {
        departamento: nadador.departamento,
        codePais: nadador.codePais,
        punto1: 0,
        punto2: 0,
        punto3: 0,
        punto4: 0,
        punto5: 0,
        punto6: 0,
        punto7: 0,
        punto8: 0,
        punto9: 0,
        punto10: 0,
        punto11: 0,
        punto12: 0,
        punto13: 0,
        punto14: 0,
        punto15: 0,
        punto16: 0,
        total: 0,
      };
    }
    if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto1+=36;
    } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto2+=32;
    } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto3+=30;
    } else if (nadador.posicion === 4 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto4+=28;
    } else if (nadador.posicion === 5 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto5+=26;
    } else if (nadador.posicion === 6 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto6+=24;
    } else if (nadador.posicion === 7 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto7+=22;
    } else if (nadador.posicion === 8 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto8+=20;
    }
    trofeoClub[nadador.nombreclub].total++;       
  });
}

function puntos10Carriles(trofeoClub, nadadores){
  nadadores.forEach((nadador) => {
    if (!trofeoClub[nadador.nombreclub]) {
      trofeoClub[nadador.nombreclub] = {
        departamento: nadador.departamento,
        codePais: nadador.codePais,
        punto1: 0,
        punto2: 0,
        punto3: 0,
        punto4: 0,
        punto5: 0,
        punto6: 0,
        punto7: 0,
        punto8: 0,
        punto9: 0,
        punto10: 0,
        punto11: 0,
        punto12: 0,
        punto13: 0,
        punto14: 0,
        punto15: 0,
        punto16: 0,
        punto17: 0,
        punto18: 0,
        punto19: 0,
        punto20: 0,
        total: 0,
      };
    }
    if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto1+=22;
    } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto2+=20;
    } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto3+=19;
    } else if (nadador.posicion === 4 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto4+=18;
    } else if (nadador.posicion === 5 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto5+=17;
    } else if (nadador.posicion === 6 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto6+=16;
    } else if (nadador.posicion === 7 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto7+=15;
    } else if (nadador.posicion === 8 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto8+=14;
    } else if (nadador.posicion === 9 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto9+=13;
    } else if (nadador.posicion === 10 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto10+=12;
    } else if (nadador.posicion === 11 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto11+=10;
    } else if (nadador.posicion === 12 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto12+=9;
    } else if (nadador.posicion === 13 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto13+=8;
    } else if (nadador.posicion === 14 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto14+=7;
    } else if (nadador.posicion === 15 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto15+=6;
    } else if (nadador.posicion === 16 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto16+=5;
    } else if (nadador.posicion === 17 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto17+=4;
    } else if (nadador.posicion === 18 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto18+=3;
    } else if (nadador.posicion === 19 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto19+=2;
    } else if (nadador.posicion === 20 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto20+=1;
    }
    trofeoClub[nadador.nombreclub].total++;       
  });
}

function puntosRelevo10Carriles(trofeoClub, nadadores){
  nadadores.forEach((nadador) => {
    if (!trofeoClub[nadador.nombreclub]) {
      trofeoClub[nadador.nombreclub] = {
        departamento: nadador.departamento,
        codePais: nadador.codePais,
        punto1: 0,
        punto2: 0,
        punto3: 0,
        punto4: 0,
        punto5: 0,
        punto6: 0,
        punto7: 0,
        punto8: 0,
        punto9: 0,
        punto10: 0,
        punto11: 0,
        punto12: 0,
        punto13: 0,
        punto14: 0,
        punto15: 0,
        punto16: 0,
        punto17: 0,
        punto18: 0,
        punto19: 0,
        punto20: 0,
        total: 0,
      };
    }
    if (nadador.posicion === 1 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto1+=40;
    } else if (nadador.posicion === 2 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto2+=36;
    } else if (nadador.posicion === 3 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto3+=34;
    } else if (nadador.posicion === 4 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto4+=32;
    } else if (nadador.posicion === 5 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto5+=30;
    } else if (nadador.posicion === 6 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto6+=28;
    } else if (nadador.posicion === 7 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto7+=26;
    } else if (nadador.posicion === 8 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto8+=24;
    }else if (nadador.posicion === 9 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto9+=22;
    }else if (nadador.posicion === 10 && nadador.tiempo !== '0:0:0') {
      trofeoClub[nadador.nombreclub].punto10+=20;
    }
    trofeoClub[nadador.nombreclub].total++;       
  });
}

export function sacarPuntosClub(resultados, nCarriles, categoriasElegidas, puntuar){
  const trofeoClub = {};

  resultados.forEach((data) => {
    if (data.nadadores) {
      const categoria = data.categoria;
      const condicionCate = categoriasElegidas.length !== 0 ? categoriasElegidas.includes(categoria) : categoria.includes('');
      if(condicionCate){
        const nadadores = data.nadadores.filter(
          (nadador) => nadador.tiempo !== "0:0:0" && nadador.tiempo !== "61:0:0");
          
        if(data.nadadores.length !== 1 || (data.nadadores.length === 1 && puntuar === 'si')){
          if(parseInt(nCarriles) <= 8){
            if(categoria.includes('Relevo')){
              puntosRelevo8Carriles(trofeoClub, nadadores);
            }else{
              puntos8Carriles(trofeoClub, nadadores);
            }
          }
  
          if(parseInt(nCarriles) === 10){
            if(categoria.includes('Relevo')){
              puntosRelevo10Carriles(trofeoClub, nadadores);
            }else{
              puntos10Carriles(trofeoClub, nadadores);
            }
          }
        }
      }
    }
  });
  // Calcular el total de medallas por club
  Object.values(trofeoClub).forEach((club) => {
    if(parseInt(nCarriles) <= 8){
      club.total = club.punto1 + club.punto2 + club.punto3 +
      club.punto4 + club.punto5 + club.punto6 + club.punto7 +
      club.punto8 + club.punto9 + club.punto10 + club.punto11 +
      club.punto12 + club.punto13 + club.punto14 + club.punto15 +
      club.punto16;
    }
    if(parseInt(nCarriles) === 10){
      club.total = club.punto1 + club.punto2 + club.punto3 +
      club.punto4 + club.punto5 + club.punto6 + club.punto7 +
      club.punto8 + club.punto9 + club.punto10 + club.punto11 +
      club.punto12 + club.punto13 + club.punto14 + club.punto15 +
      club.punto16 + club.punto17 + club.punto18 + club.punto19 +
      club.punto20;
    }
  });
  const auxTrofeoClub = Object.entries(trofeoClub)
    .map(([club, values]) => ({
      club,
      ...values,
    }))
    .sort((a, b) => {return b.total - a.total});
  
  return auxTrofeoClub;
}

//autorizaciones
export async function actualizarClubesAutorizados(actualizarAutorizados){
  if(actualizarAutorizados){
    const docuRef = doc(firestore, `autorizacion/XKF4ZIAy7gkrtm7Batwk`);
    updateDoc(docuRef, {autorizados: actualizarAutorizados}).catch(() =>{
      toast.error('UPS!! Ocurrio un error, intentalo de nuevo o comunicate con el administrador de la plataforma.');
    })
  }
}

export async function eliminarClubesAutorizados(nombresAutorizados, nombre){
  if(nombresAutorizados.length !== 0){
    const docuRef = doc(firestore, `autorizacion/XKF4ZIAy7gkrtm7Batwk`);
    updateDoc(docuRef, {autorizados: nombresAutorizados}).then(() =>{
      toast.success('El equipo ' + nombre.nombre + ', ya no esta autorizado para registrarse/ingresar.',{
        icon: '😢'
      });
    }).catch(() =>{
      toast.error('UPS!! Ocurrio un error, intentalo de nuevo o comunicate con el administrador de la plataforma.');
    })
  }else{
    const deleteDoc = doc(firestore, `autorizacion/XKF4ZIAy7gkrtm7Batwk`);
    await updateDoc(deleteDoc, {
      autorizados: deleteField()
    });
  }
}

export function registrarNombreAutorizado(nombresAutorizados, nombre, sesion){
  const docuRef = doc(firestore, `autorizacion/XKF4ZIAy7gkrtm7Batwk`);
  if(nombre && sesion === 'si'){
    registrarNombresListado(nombre);
  }
  updateDoc(docuRef, {autorizados: nombresAutorizados}).then(() =>{
    if(nombre){
      toast.success('Equipo ' + nombre + ', autorizado.');
    }
  }).catch(() =>{
    toast.error('UPS!! Ocurrio un error, intentalo de nuevo o comunicate con el administrador de la plataforma.');
  })
}

export async function registrarNombresListado(club){
  const docuRef = doc(firestore, `listadoNombres/XKF4ZIAy7gkrtm7Batwk`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const auxClubes = [];
    docSnap.data().clubes.forEach((clu)=>{
      auxClubes.push(clu);
    })
    updateDoc(docuRef, {clubes: [...auxClubes, club]});
  }else{
    setDoc(docuRef, {clubes: [club]});
  }
}

export async function eliminarClubDelListado(club){
  const docuRef = doc(firestore, `listadoNombres/XKF4ZIAy7gkrtm7Batwk`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const clubEncontrado = docSnap.data().clubes.filter((clu)=>{return clu === club});
    const auxClubes = docSnap.data().clubes.filter((clu)=>{return clu !== club});
    if(clubEncontrado.length !== 0){
      updateDoc(docuRef, {clubes: [...auxClubes]});
    }
  }
}

let unsubscribeNombresListado = null;

export function buscarNombresListado(setNombres){
  unsubscribeNombresListado = onSnapshot(doc(firestore, "listadoNombres", `XKF4ZIAy7gkrtm7Batwk`), (doc) => {
    if(doc.data()){
      setNombres(doc.data().clubes.sort())
    }else{
      setNombres([])
    }
  });
}

export function cancelarNombresListado(){
  if (unsubscribeNombresListado) {
    unsubscribeNombresListado();
    unsubscribeNombresListado = null;
  }
}

let unsubscribeNombresAutorizados = null;

export function buscarNombresAutorizados(setNombresAutorizados){
  unsubscribeNombresAutorizados = onSnapshot(doc(firestore, "autorizacion", `XKF4ZIAy7gkrtm7Batwk`), (doc) => {
    if(doc.data()){
      setNombresAutorizados(doc.data().autorizados)
    }else{
      setNombresAutorizados([])
    }
  });
}

export function cancelarNombresAutorizados(){
  if (unsubscribeNombresAutorizados) {
    unsubscribeNombresAutorizados();
    unsubscribeNombresAutorizados = null;
  }
}

let unsubscribeAutorizaciones = null;

export function buscarAutorizaciones(setAutorizaciones){
  unsubscribeAutorizaciones = onSnapshot(doc(firestore, "autorizacion", `XKF4ZIAy7gkrtm7Batwk`), (doc) => {
    if(doc.data()){
      setAutorizaciones(doc.data().autorizados.map((user)=>{return user.autorizado}))
    }else{
      setAutorizaciones([])
    }
  });
}

export function cancelarAutorizaciones(){
  if (unsubscribeAutorizaciones) {
    unsubscribeAutorizaciones();
    unsubscribeAutorizaciones = null;
  }
}

// Función para eliminar las fotos existentes en la subcolección de convocatorias
async function eliminarFotosPerfilExistente(id) {
  const fotosRef = ref(storagePws, `${id}/perfil/`);
  const fotosList = await listAll(fotosRef);
  
  // Eliminar cada foto en la subcolección
  fotosList.items.forEach(async (item) => {
    await deleteObject(item);
  });
}

//operaciones para el perfil del usuario
//funcion para subir foto de perfil
export function subirFotoPerfil(file, id, setImgPerfil, usuario) {

  eliminarFotosPerfilExistente(id);

  const nombreFoto = ref(storagePws, `${id}/perfil/${file.name}`);
  const auxPerfil = uploadBytes(nombreFoto, file)
  .then(() => {
    getDownloadURL(nombreFoto).then((url) => {
      updateProfile(auth.currentUser, {
        photoURL: url,
      })
      setImgPerfil(url);
      usuario.photo = url;
    });
  })
  toast.promise(auxPerfil, {
    loading: 'Subiendo Foto...',
    success: () => "Tu foto ha sido cargada con éxito.",
    error: () => "Ocurrió un error al subir la foto."
  })
}

//funcion para elminar foto de perfil
export function eliminarFotoPerfil(setImgPerfil, file, usuario) {
  const auxPerfil = updateProfile(auth.currentUser, {
    photoURL: "",
  })
  .then(() => {
    const nombreFoto = ref(storagePws, `${file}`);
    deleteObject(nombreFoto)
      .then(() => {
        setImgPerfil();
        usuario.photo = null;
      })
  })

  toast.promise(auxPerfil, {
    loading: 'Eliminando Foto...',
    success: () => "Tu foto de perfil ha sido eliminada con éxito.",
    error: () => "Se produjo un error al eliminar la foto, inténtalo de nuevo."
  })
}

export function updateDatos(nuevosDatos) {
  if (nuevosDatos.nombre !== "") {
    updateProfile(auth.currentUser, {
      displayName: nuevosDatos.nombre,
    }).catch(() => {
      toast.error("Hubo un error al actualizar el nombre, intente nuevamente.");
    });
  }

  if (nuevosDatos.passwordNuevo !== "") {
    const credencial = EmailAuthProvider.credential(
      auth.currentUser.email,
      nuevosDatos.passwordActual
    );
    reauthenticateWithCredential(auth.currentUser, credencial)
      .then(() => {
        updatePassword(auth.currentUser, nuevosDatos.passwordNuevo)
          .then(() => {
            toast.success("Los datos se han actualizado correctamente.");
          })
          .catch(() => {
            toast.error(
              "Hubo un error al actualizar la contraseña, intente nuevamente."
            );
          });
      })
      .catch(() => {
        toast.error(
          "¡¡ups!! Parece que la contraseña actual es incorrecta, inténtalo de nuevo."
        );
      });
  }
}

// ------------------ configuracion para generar un id a cada torneo creado ----------------------

/* La funcion generarId() nos ayudara a generar un id unico con 20 caracteres */
export function generarId() {
  const caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let nuevaContrasena = "";
  for (let i = 0; i < 20; i++) {
    nuevaContrasena += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return nuevaContrasena;
}

// ------------------ configuracion de torneos temporales ----------------------
function enviarCorreoInvitacion(titulo, nombreclub, email, torneo, fechaTorneoFormat, fechaTorneoFFormat, fechaTorneoInscripcionesFormat){
  const text = `
    <div style="font-family:Arial, sans-serif; background:#f6f9fc; padding:30px; text-align:center;">

      <div style="max-width:520px; margin:auto; background:#ffffff; border-radius:12px; padding:30px; box-shadow:0 4px 10px rgba(0,0,0,0.08);">

        <img src="https://firebasestorage.googleapis.com/v0/b/orcas-valle.appspot.com/o/img_logo.png?alt=media&token=3de7af94-afef-4449-9ea0-aa63aa7b46d1"
             alt="ProWebSports"
             style="width:160px; margin-bottom:25px;">

        <p style="color:#333; font-size:15px;">
          Hola <strong>${nombreclub}</strong>,
          <br><br>
          Estás cordialmente invitado a participar en el gran evento:
        </p>

        <p style="color:#0066ff; font-size:18px; font-weight:bold; margin:15px 0;">
          ${titulo} - ${datosAdmin.nombre}
        </p>

        <!-- Información del evento -->
        <div style="text-align:left; background:#f1f4f8; padding:18px; border-radius:10px; margin-top:15px; font-size:14px; color:#333; line-height:1.6;">

          <p style="margin:6px 0;">🗓️ <b>Fecha del evento:</b> ${fechaTorneoFormat} - ${fechaTorneoFFormat}</p>

          <p style="margin:6px 0;">⏳ <b>Cierre de inscripciones:</b> ${fechaTorneoInscripcionesFormat}</p>

          <p style="margin:6px 0;">🏊‍♂️ <b>Piscina:</b> ${torneo.piscina} metros</p>

          <p style="margin:6px 0;">🏙️ <b>Ciudad:</b> ${torneo.ciudad}</p>

          <p style="margin:6px 0;">📍 <b>Dirección:</b> ${torneo.direccion}</p>

          <p style="margin:6px 0;">💵 <b>Valor por equipo:</b> $${parseInt(torneo.valorClub).toLocaleString()}</p>

          <p style="margin:6px 0;">💵 <b>Valor por deportista:</b> $${parseInt(torneo.valorDeportista).toLocaleString()}</p>

        </div>

        <!-- Contacto -->
        <div style="margin-top:20px; font-size:14px; color:#333;">
          <p style="margin:6px 0;"><b>Contacto del organizador:</b></p>
          <p style="margin:4px 0;"><b>${datosAdmin.encargado}</b></p>
          <p style="margin:4px 0;">📱 ${datosAdmin.cel}</p>
          <p style="margin:4px 0;">✉️ ${datosAdmin.email}</p>
        </div>

        <p style="color:#333; font-size:15px; margin-top:25px;">
          ¡No pierdas la oportunidad de ser parte de esta gran competencia! 🏆
        </p>

        <a href="${datosAdmin.plataforma}"
           style="display:inline-block; background:#0066ff; color:white; padding:12px 20px; border-radius:8px; text-decoration:none; margin-top:15px;">
           Ver evento / Inscribirme
        </a>

        <hr style="border:none; border-top:1px solid #eee; margin:30px 0;">

        <p style="color:#999; font-size:12px; line-height:1.5;">© PROWEBSPORTS — Alquilamos plataformas digitales para la administración de competencias de natación, incluyendo el uso de nuestro sistema semiautomático de cronometraje.</p>

      </div>

    </div>
    `;
  sendEmail(`INVITACIÓN - ${titulo} - ${datosAdmin.nombre}`, text, [email]);
}

export async function traerUsuarioInvitacion(){
  const docRef = collection(firestoreRankingPws, `usuarios`);
  const docSnap = await getDocs(docRef);
  const correos = [];
  docSnap.docs.forEach((usu)=>{
    correos.push(usu.data());
  })
  return correos;
}

let contadorNotificacionTorneos = 0;
let contadorInvitacionTorneos = 0;
export function notificarNuevoEvento(torneo){
  const auxFechaTorneo = new Date(torneo.fechaTorneo);
  auxFechaTorneo.setDate(auxFechaTorneo.getDate() + 1);
  const auxFechaTorneoF = new Date(torneo.fechaTorneoF);
  auxFechaTorneoF.setDate(auxFechaTorneoF.getDate() + 1);
  const auxFechaInscripciones = new Date(torneo.fechaInscripciones);
  const fechaTorneoFormat = auxFechaTorneo.toLocaleString('es-ES',{
    year: 'numeric',
    month: 'long',
    day: 'numeric'})
  const fechaTorneoFFormat = auxFechaTorneoF.toLocaleString('es-ES',{
    year: 'numeric',
    month: 'long',
    day: 'numeric'})
  const fechaTorneoInscripcionesFormat = auxFechaInscripciones.toLocaleString('es-ES',{
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true})
  const auxInvitacion = toast.loading(`Enviando invitación. Esto puede tardar unos minutos o segundos.`);
  traerTokensNotificaciones().then((tokens)=>{
    if(contadorNotificacionTorneos === 0){
      tokens.forEach((token)=>{
        const text = `🎉Estas cordialmente invitado al gran evento.🎉\n\n•🗓️ Fecha evento: ${fechaTorneoFormat} - ${fechaTorneoFFormat}\n•🗓️ Fecha cierre inscripciones: ${fechaTorneoInscripcionesFormat}\n•🏊🏼‍♂️ Piscina: ${torneo.piscina} metros\n•🏙️ Ciudad: ${torneo.ciudad}\n•🧭 Dirección: ${torneo.direccion}\n•💵 Club: $${parseInt(torneo.valorClub).toLocaleString()}\n•💵 Deportista: $${parseInt(torneo.valorDeportista).toLocaleString()}\n•📱Contacto: ${datosAdmin.cel}\n•✉️ E-mail: ${datosAdmin.email}`;
        notificacion(token, text, `${torneo.titulo} - ${datosAdmin.nombre}`).catch(() =>{
          eliminarTokenNotificacion(token.token);
        });
      })
      contadorNotificacionTorneos++;
    }
  });
  traerUsuarioInvitacion().then((usuarios)=>{
    if(contadorInvitacionTorneos === 0){
      let index = 0;
      const interval = setInterval(async () => {
        if (index >= usuarios.length) {
          clearInterval(interval);
          toast.dismiss(auxInvitacion);
          toast.success('Invitación enviada a todos correctamente.');
          return;
        }

        const usuario = usuarios[index];
        enviarCorreoInvitacion(torneo.titulo, usuario.nombreclub, usuario.email, torneo, fechaTorneoFormat, fechaTorneoFFormat, fechaTorneoInscripcionesFormat);
        index++;
      }, 1500);
      contadorInvitacionTorneos++;
    }
  })
}

/* La funcion registrarTorneoTemporal nos ayudara a registrar el torneo que se esta editando en un espacio temporal */
export function registrarTorneoTemporal(idTorneo, torneo) {
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  setDoc(docuRef, torneo).then(()=>{
    registrarTorneoFamilia(idTorneo, torneo);
  });
}

/* La funcion registrarTorneoTemporal nos ayudara a registrar el torneo que se esta editando en un espacio temporal */
export function editarTorneoTemporal(idTorneo, torneo) {
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  try {
    const auxObjTorneo = {
      titulo: torneo.titulo,
      carrilInicio: torneo.carrilInicio,
      carrilFin: torneo.carrilFin,
      carril: torneo.carril,
      valorClub: torneo.valorClub,
      valorDeportista: torneo.valorDeportista,
      direccion: torneo.direccion,
      fechaTorneo: torneo.fechaTorneo,
      fechaTorneoF: torneo.fechaTorneoF,
      edCumplida: torneo.edCumplida,
      regTiempo: torneo.regTiempo,
      publicidad: torneo.publicidad,
      idFinales: torneo.idFinales,
      fechaInscripciones: torneo.fechaInscripciones,
      ubicacionLatLng: torneo.ubicacionLatLng,
      ciudad: torneo.ciudad,
      piscina: torneo.piscina,
      cronometros: torneo.cronometros,
      series: torneo.series,
      puntuacion: torneo.puntuacion,
      plataforma: torneo.plataforma,
      digitador: torneo.digitador,
      cronos: torneo.cronos,
      privacidad: torneo.privacidad
    }
    if(torneo.urlResultados){
      auxObjTorneo.urlResultados = torneo.urlResultados;
    }
    updateDoc(docuRef, auxObjTorneo).then(()=>{
      registrarTorneoFamilia(idTorneo, torneo);
    });
    toast.success('Torneo actualizado correctamente.');
  } catch (error) {
    toast.success('UPS! Ocurrio un error al actualizar el torneo. Intentalo de nuevo.');
  }
}

/* La funcion traerTorneosTemporales nos ayudara a traer todos los torneos que estan en el espacio temporal el cual se editaran. */
export function traerTorneosTemporales(setListaTorneos) {
  onSnapshot(collection(firestore, "TorneosTemporales"), (docc) => {
    const auxTorneo = [];
    if(docc.docs.length !== 0){
      docc.docs.map((user) => {
        return auxTorneo.push(user.data());
      });
    }

    auxTorneo.sort((a, b)=> new Date(b.fechaTorneoF) - new Date(a.fechaTorneoF));

    auxTorneo.forEach((auxTor)=>{
      const fecha = new Date(auxTor.fechaInscripciones);
      auxTor.fechaInscripciones = fecha.toLocaleString('en-US',{ 
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true})
    })
    
    setListaTorneos([
      ...auxTorneo
    ]);
  });
}

let unsubscribeCantNadadores = null;

export async function cantidadDeportistas(idTorneo) {
  const docuRef = collection(firestore, `TorneosTemporales/${idTorneo}/deportistas`);
  const torneos = await getDocs(docuRef);
  return torneos.docs.length;
}

export function cancelarCantNadadores(){
  if (unsubscribeCantNadadores) {
    unsubscribeCantNadadores();
    unsubscribeCantNadadores = null;
  }
}

/* La funcion actualizarTorneoTemporal nos ayudara con los cambios del torneo. */
export function actualizarTorneoTemporal(idTorneo, torneo) {
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  updateDoc(docuRef, torneo);
}

/* La funcion eliminarTorneoTemporal nos ayudara con la eliminación de un curso que no se quiera publicar. */
export async function eliminarTorneoTemporal(idTorneo) {
  eliminarBaseDeDatosLocal(idTorneo);
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  const subColeccionClubes = collection(docuRef, 'clubes');
  const subColeccionPlanilla = collection(docuRef, 'planilla');
  const subColeccionTiempos = collection(docuRef, 'tiempos');
  const docSnapClubes = await getDocs(subColeccionClubes);
  const docSnapPlanilla = await getDocs(subColeccionPlanilla);
  const docSnapTiempos = await getDocs(subColeccionTiempos);
  
  docSnapClubes.forEach(async (sub)=>{
    if(sub.exists()){
      await deleteDoc(sub.ref);
    }
  })
  docSnapPlanilla.forEach(async (sub)=>{
    if(sub.exists()){
      await deleteDoc(sub.ref);
    }
  })
  docSnapTiempos.forEach(async (sub)=>{
    if(sub.exists()){
      await deleteDoc(sub.ref);
    }
  })
  deleteDoc(docuRef);
}
// ------------------ fin de configuracion de torneos temporales ----------------------

// ------------------ configuracion de planillas ----------------------

/* La funcion guardarJPPlanilla nos ayudara a registrar cada jornada con sus respetivas pruebas a planilla que se esta editando en el espacio temporal */
export function guardarJPPlanilla(idTorneo, jornadas){
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  updateDoc(docuRef, {jornadas});
}

// ------------------ fin configuracion de planillas ----------------------

// ------------------ configuracion de participacion club e inscripciones ----------------------

//esta funcion nos ayudara a traer los clubes autorizados y asi llevar un control de ellos.
export async function traerClubesAutorizados(){
  const docRef = doc(firestore, "autorizacion", `XKF4ZIAy7gkrtm7Batwk`);
  const docSnap = await getDoc(docRef)
  const nombre = docSnap.data().autorizados;
  return nombre;
}

function enviarCorreoInscripcion(titulo, nombreclub, email){
  const text = `
    <div style="font-family:Arial, sans-serif; background:#f6f9fc; padding:30px; text-align:center;">

      <div style="max-width:520px; margin:auto; background:#ffffff; border-radius:12px; padding:30px; box-shadow:0 4px 10px rgba(0,0,0,0.08);">

        <img src="https://firebasestorage.googleapis.com/v0/b/orcas-valle.appspot.com/o/img_logo.png?alt=media&token=3de7af94-afef-4449-9ea0-aa63aa7b46d1"
             alt="ProWebSports"
             style="width:160px; margin-bottom:25px;">

        <p style="color:#333; font-size:15px;">
          Hola <strong>${nombreclub}</strong>,
          <br><br>
          Queremos darte la bienvenida y agradecerte por inscribirte en el evento:
        </p>

        <p style="color:#0066ff; font-size:18px; font-weight:bold; margin:15px 0;">
          ${titulo} - ${datosAdmin.nombre}
        </p>

        <p style="color:#333; font-size:15px;">
          Tu participación es muy importante para nosotros y estamos seguros de que será una gran experiencia deportiva.
          <br><br>
          A continuación, te dejamos la información del organizador en caso de que necesites comunicarte:
        </p>

        <div style="background:#f1f4f8; padding:15px; border-radius:8px; margin-top:15px; color:#333; font-size:14px;">
          <b>${datosAdmin.encargado}</b><br>
          📞 ${datosAdmin.cel}<br>
          ✉️ ${datosAdmin.email}
        </div>

        <p style="color:#333; font-size:15px; margin-top:25px;">
          ¡Te deseamos mucho éxito en la competencia! 🏆
        </p>

        <hr class="my-1" style="border:none; border-top:1px solid #eee; margin:30px 0;">

        <p style="color:#999; font-size:12px; line-height:1.5;">© PROWEBSPORTS — Alquilamos plataformas digitales para la administración de competencias de natación, incluyendo el uso de nuestro sistema semiautomático de cronometraje.</p>

      </div>

    </div>
    `;
  sendEmail(`INSCRIPCIÓN CONFIRMADA - ${titulo} - ${datosAdmin.nombre}`, text, [email]);
}

//Esta funcion nos ayudara a registrar al club al darle en el boton participar
let contadorNotificacion = 0;
export async function registrarClubAlTorneo(id, club, idForanea, photoActual, torneoEspecifico) {
  if(id !== ''){
    const docuRef = doc(firestore, `TorneosTemporales/${id}`, `clubes/${idForanea}`);
    const clubesInscritos = await getDoc(docuRef);
    if(!clubesInscritos.exists()){
      traerClubesAutorizados().then((auto)=>{
        for (let i = 0; i < auto.length; i++) {
          if(auto[i].nombre === club.nombreclub){
            club.abreviatura = auto[i].abreviatura;
            club.codePais = auto[i].codePais;
            club.departamento = auto[i].departamento;
          }
        }
        setDoc(docuRef, club).then(()=>{
          traerTokensNotificacionInscripciones().then((tokens)=>{
            if(contadorNotificacion === 0){
              tokens.forEach((token)=>{
                notificacion(token, `Se inscribió en ${torneoEspecifico.titulo}`, club.nombreclub).catch(() =>{
                  eliminarTokenNotificacion(token.token)
                });
              })
              enviarCorreoInscripcion(torneoEspecifico.titulo, club.nombreclub, club.email);
              contadorNotificacion++;
            }
          });
        });
      })
    }else{
      if(clubesInscritos.data().photo === null || clubesInscritos.data().photo !== photoActual){
        updateDoc(docuRef, {photo: club.photo});
      }
    }
  }
}

//esta funcion nos ayudara a registrar los nadadores para la competencia.
export async function registrarNadador(id, deportista){
  const docuRef = doc(firestore, `TorneosTemporales/${id}`, `deportistas/${deportista.identificacion}`);
  const docSnap = await getDoc(docuRef);
  if(!docSnap.exists()){
    setDoc(docuRef, deportista).then(() =>{
      toast('Deportista ' + deportista.nombre + ', se ha registrado correctamente.',{
        icon: '🏊🏊‍♀️'
      });
    }).catch(() =>{
      toast.error('UPS!! Ocurrio un error, intentalo de nuevo.');
    })
  }else{
    updateDoc(docuRef, deportista).then(() =>{
      toast('Deportista ' + deportista.nombre + ', se ha modificado correctamente.',{
        icon: '🏊🏊‍♀️'
      });
    }).catch(() =>{
      toast.error('UPS!! Ocurrio un error, intentalo de nuevo.');
    })
  }
}

//Esta funcion nos ayudara a traer los nadadores de un club especifico.
let unsubscribeRelevosEquipo = null;

export function traerRelevosEquipo(idTorneo, idClub, setRelevoEquipo){
  if(idTorneo !== ''){
    const docRef = doc(firestore, `TorneosTemporales/${idTorneo}/clubes/${idClub}`);
    unsubscribeRelevosEquipo = onSnapshot(docRef, (docSnap) => {
      if(docSnap.exists()){
        const nombreRelevo = docSnap.data() ? docSnap.data().relevos : [];
        if(nombreRelevo.length !== 0) {
          nombreRelevo.sort(function (a, b) {
            return a.edad - b.edad;
          });
        }
        setRelevoEquipo(nombreRelevo);
      }
    });
  }
}

// Función para cancelar la suscripción
export function cancelarSuscripcionRelevosEquipo() {
  if (unsubscribeRelevosEquipo) {
    unsubscribeRelevosEquipo();
    unsubscribeRelevosEquipo = null;
  }
}

let unsubscribeDeportistas = null;

export function traerDeportistas(idTorneo, setDeportistas){
  if(idTorneo !== ''){
    const docRef = collection(firestore, `TorneosTemporales/${idTorneo}/deportistas`);
    unsubscribeDeportistas = onSnapshot(docRef, (docSnap) => {
      const auxDeportistas = [];
      docSnap.docs.forEach((deport) =>{
        auxDeportistas.push(deport.data());
      })

      auxDeportistas.sort(function (a, b) {
        return a.edad - b.edad;
      });

      setDeportistas(auxDeportistas);
    });
  }
}

// Función para cancelar la suscripción
export function cancelarSuscripcionDeportistas() {
  if (unsubscribeDeportistas) {
    unsubscribeDeportistas();
    unsubscribeDeportistas = null;
  }
}

let unsubscribeTraerClubes = null;

//operaciones para traer los datos de los clubes inscritos
export function traerClubes(idTorneo, setClubes){
  if(idTorneo.length !== 0){
    const clubesRef = collection(firestore, `TorneosTemporales/${idTorneo}/clubes`);
    unsubscribeTraerClubes = onSnapshot(clubesRef, (snapshot) => {
      const clubesInscritos = [];
  
      snapshot.forEach((doc) => {
        clubesInscritos.push(doc.data());
      });

      clubesInscritos.sort((a, b)=> {
        if(a.nombreclub > b.nombreclub){
          return 1;
        }else if(a.nombreclub < b.nombreclub){
          return -1;
        }
        return 0;
      });
      
      setClubes(clubesInscritos);
    });
  }
}

// Función para cancelar la suscripción
export function cancelarSuscripcionTraerClubes() {
  if (unsubscribeTraerClubes) {
    unsubscribeTraerClubes();
    unsubscribeTraerClubes = null;
  }
}

//Esta funcion nos ayudara a modificar los datos del club.
export function registrarDirectivosClub(id, directivos, idTorneo){
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}/clubes/${id}`);
  updateDoc(docRef, { 
    directivos
  }
  ).then(() =>{
    toast.success('Directivos registrados correctamente.');
  });
}

export async function traerDirectivos(idTorneo, idClub, setDirectivos, setDialogDirectivos){
  const docuRef = doc(firestore, `TorneosTemporales/${idTorneo}/clubes/${idClub}`);
  const club = await getDoc(docuRef);

  if(club.exists()){
    if(club.data().directivos){
      if(club.data().directivos[0].nombre !== ''){
        setDirectivos(club.data().directivos.sort((a, b) => a.id - b.id));
      }else{
        setDialogDirectivos(true);
      }
    }else{
      setDialogDirectivos(true);
    }
  }
}

//operaciones para eliminar nadadores
export async function eliminarNadador(deportista, id){
  const docuRef = doc(firestore, `TorneosTemporales/${id}/deportistas/${deportista.identificacion}`);
  deleteDoc(docuRef).then(() =>{
    toast.success('Deportista ' + deportista.nombre + ', se ha eliminado correctamente.',{
      icon: '😢'
    });
  }).catch(() =>{
    toast.error('UPS!! Ocurrio un error, intentalo de nuevo.');
  })
}

//Esta funcion nos ayudara a traer un club especifico.
export async function traerClubesDelTorneo(id, idForanea){
  const docRef = doc(firestore, `TorneosTemporales/${id}`, `clubes/${idForanea}`);
  const docSnap = await getDoc(docRef)
  const clubes = docSnap.data().clubes;
  return clubes;
}

// ------------------ fin configuracion de participacion club e inscripciones ----------------------
//---------------------- configuracion mensajes ----------------------
export async function registrarMensaje(idTorneo, mensaje){
  const id = generarId();
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}/mensajes/${id}`);
  const docSnap = await getDoc(docRef);
  if(!docSnap.exists()){
    mensaje.id = id;
    setDoc(docRef, mensaje);
  }
}

let unsubscribeMensajes = null;

export async function traerMensajes(idTorneo, setMensajes){
  if(idTorneo){
    const mensajesCollectionRef = collection(firestore, `TorneosTemporales/${idTorneo}/mensajes`);
    
    unsubscribeMensajes = onSnapshot(mensajesCollectionRef, (querySnapshot) => {
      const mensajes = querySnapshot.docs
        .filter((doc) => doc.exists)
        .map((doc) => doc.data())
        .sort((a, b) => {
          const fechaA = new Date(a.fecha);
          const fechaB = new Date(b.fecha);
          return fechaA - fechaB;
        });
  
      setMensajes(mensajes);
    });
  }
}

export function cancelarMensajes(){
  if (unsubscribeMensajes) {
    unsubscribeMensajes();
    unsubscribeMensajes = null;
  }
}

export function eliminarMensaje(idTorneo, idMensaje){
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}/mensajes/${idMensaje}`);
  deleteDoc(docRef);
}
//---------------------- fin configuracion mensajes ------------------
// ------------------ configuracion de facturacion participacion ----------------------
export async function registrarFacturacionParticipacion(id, idForanea, pago){
  const docuRef = doc(firestore, `TorneosTemporales/${id}/clubes/${idForanea}`);
  updateDoc(docuRef, {pago}).then(() =>{
    toast.success(`Se actualizo el pago correctamente.`);
  }).catch(() =>{
    toast.error('UPS!! Ocurrio un error, intentalo de nuevo o comunicate con el administrador de la pagina.');
  })
}
// ------------------ fin configuracion de facturacion participacion ------------------
// ------------------ configuracion del JPC (Jornadas, Pruebas, Categorias) ----------------------

/* La funcion generarIdPrueba() nos ayudara a generar un id unico con 10 caracteres para cada prueba*/
export function generarIdPrueba() {
  const caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let nuevaContrasena = "";
  for (let i = 0; i < 10; i++) {
    nuevaContrasena += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return nuevaContrasena;
}

//Esta funcion nos ayudara a registrar cada prueba en nuestras bases de datos.
export async function registrarPrueba(pruebas){
  const docuRef = doc(firestore, `jpc/${pruebas[0].categoria}`);
  const pruebasInscritas = await getDoc(docuRef);
  if(pruebasInscritas.exists()){
    const aux = [...pruebasInscritas.data().pruebas, ...pruebas];
    updateDoc(docuRef, {pruebas: aux});
    toast.success("Prueba registrada correctamente.");
  }else{
    const aux = [...pruebas];
    setDoc(docuRef, {pruebas: aux})
    toast.success("Prueba registrada correctamente.");
  }
}

//Esta funcion nos ayudara a registrar cada prueba en nuestras bases de datos.
export async function registrarCantPruebaPorCategoria(cantPruebas, categoria){
  const docuRef = doc(firestore, `jpc/${categoria}`);
  const pruebasInscritas = await getDoc(docuRef);
  if(pruebasInscritas.exists()){
    updateDoc(docuRef, {cantPruebas});
    toast.success("Cantidad de pruebas registrada correctamente.");
  }else{
    setDoc(docuRef, {cantPruebas})
    toast.success("Cantidad de pruebas registrada correctamente.");
  }
}

//Esta funcion nos ayudara a registrar cada prueba en nuestras bases de datos.
export async function eliminarPruebas(prueba, categoria){
  const docuRef = doc(firestore, `jpc/${categoria}`);
  const pruebasInscritas = await getDoc(docuRef);
  if(pruebasInscritas.exists()){
    const auxPruebas = [];
    for (let i = 0; i < pruebasInscritas.data().pruebas.length; i++) {
      if(pruebasInscritas.data().pruebas[i].prueba !== prueba){
        auxPruebas.push(pruebasInscritas.data().pruebas[i]);
      }
    }

    if(auxPruebas.length !== 0){
      updateDoc(docuRef, {pruebas: auxPruebas});
    }else{
      deleteDoc(docuRef);
    }
    toast.success("Prueba eliminada correctamente.");
  }
}

//Esta funcion nos ayudara a traer las pruebas para la seccion registro JPC.
export async function traerPruebasParaRegistroJPC(setPruebas){
  onSnapshot(collection(firestore, "jpc"), (docc) => {
    const auxPruebas = [];
    if(docc.docs.length !== 0){
      docc.docs.forEach((user) => {
         auxPruebas.push(...user.data().pruebas);
      });
    }
    setPruebas(auxPruebas);
  });
}

// ------------------ fin configuracion del JPC (Jornadas, Pruebas, Categorias) -------------------------------

// ------------------ configuracion del la automatizacion de planillas ----------------------
//operacion para registrar las tablas.
export async function registrarTablasPlanilla(id, pruebas, nadadoresCarriles, fecha){
  const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${pruebas.id}`);
  const docSnap = await getDoc(docRef);

  if(nadadoresCarriles[0]){
    for (let i = 0; i < nadadoresCarriles.length; i++) {
      for (let j = 0; j < nadadoresCarriles[i].nadadores.length; j++){
        if(nadadoresCarriles[i].nadadores[j].identificacion[0]){
          const deport = pruebas.deportistas.filter((depor)=>{return depor.identificacion === nadadoresCarriles[i].nadadores[j].identificacion[0]})
          if(deport.length !== 0){
            const pruebaEncontrada = deport[0].records.filter((prue)=>{return prue.prueba === pruebas.prueba.id})
            nadadoresCarriles[i].nadadores[j].record = pruebaEncontrada[0].record;
          }else{
            nadadoresCarriles[i].nadadores[j].record = '0:0:0';
          }
          if(!docSnap.exists()){
            setDoc(docRef, {
              id: pruebas.id,
              fechaR: fecha,
              prueba: pruebas.prueba.prueba,
              categoria: pruebas.categoria,
              planilla: nadadoresCarriles
            });
          }else{
            updateDoc(docRef, {
              id: pruebas.id,
              fechaR: fecha,
              prueba: pruebas.prueba.prueba,
              categoria: pruebas.categoria,
              planilla: nadadoresCarriles
            });
          }
        }
      }
    }
  }else{
    if(!docSnap.exists()){
      setDoc(docRef, {
        id: pruebas.id,
        fechaR: fecha,
        prueba: pruebas.prueba.prueba,
        categoria: pruebas.categoria,
        planilla: []
      });
    }else{
      updateDoc(docRef, {
        id: pruebas.id,
        fechaR: fecha,
        prueba: pruebas.prueba.prueba,
        categoria: pruebas.categoria,
        planilla: []
      });
    }
  }
}

export async function traerTodasTablasPlanilla(id, setPlanilla, setFechaRegistroProgramacion){
  if(id.length !== 0){
    const docRef = collection(firestore, `TorneosTemporales/${id}/planilla`);
    // Escucha cambios en la colección "planilla"
    onSnapshot(docRef, (querySnapshot) => {
      const updatedPlanilla = [];
      const planilla = [];
      querySnapshot.forEach((doc) => {
        const planillaDoc = doc.data();
        updatedPlanilla.push(planillaDoc);
      });
  
      // Ordena la planilla por algún criterio si es necesario
      updatedPlanilla.sort((a, b) => a.id - b.id);

      updatedPlanilla.forEach((pla)=>{
        planilla.push(pla.planilla);
      })

      const fechaRegistro = new Date(updatedPlanilla[0]?.fechaR).toLocaleString('es-ES',{ 
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        weekday: 'long'
      });

      setPlanilla(planilla);
      setFechaRegistroProgramacion(fechaRegistro !== 'Invalid Date' ? fechaRegistro : 'No se ha registrado aún.');
    });
  }
}

export async function traerProgramacionRegistrada(idTorneo, setProgramacion){
  const docRef = collection(firestore, `TorneosTemporales/${idTorneo}/planilla`);
  const docSnap = await getDocs(docRef);
  const auxProgramacion = [];
  docSnap.forEach((programa)=>{
    auxProgramacion.push(programa.data());
  })

  auxProgramacion.sort((a, b) => a.id - b.id);
  setProgramacion(auxProgramacion);
}

function unirYBuscarPrueba(jornadas, pruebaId){
  let nombrePrueba = '';
  jornadas.forEach((jor)=>{
    jor.pruebas.forEach((prue)=>{
      if(prue.id === pruebaId){
        nombrePrueba = prue.prueba;
      }
    })
  })
  return nombrePrueba;
}

//planillas
export async function organizarPorTiempos(cc, tiempos, jornadas, piscina){
  const deport = doc(firestoreRankingPws, `ranking/${cc + ''}`);
  const docDeport = await getDoc(deport);
  const auxTiempos = [];
  if(docDeport.exists()){
    tiempos.forEach((prue)=>{
      const pruebaEncontrada = docDeport.data().pruebas.filter((p)=>{return p.prueba === unirYBuscarPrueba(jornadas, prue.prueba) && p.piscina === piscina});
      if(pruebaEncontrada.length === 0){
        const aux = {
          prueba: prue.prueba,
          record: prue.record
        }
        
        auxTiempos.push(aux);
      }else{

        const auxTiempoA = prue.record.split(':');
        const auxTiempoB = pruebaEncontrada[0].record.split(':');

        const auxMilisegundosA = parseInt(auxTiempoA[0]) * 60 * 1000 + parseInt(auxTiempoA[1]) * 1000 + parseInt(auxTiempoA[2]);
        const auxMilisegundosB = parseInt(auxTiempoB[0]) * 60 * 1000 + parseInt(auxTiempoB[1]) * 1000 + parseInt(auxTiempoB[2]);

        const aux = {
          prueba: prue.prueba,
          record: prue.record
        }

        if(auxMilisegundosA >= auxMilisegundosB || prue.record === '0:0:0'){
          aux.record =  pruebaEncontrada[0].record;
        }
        
        auxTiempos.push(aux);
      }
    })
  }else{
    tiempos.forEach((prue)=>{
      const aux = {
        prueba: prue.prueba,
        record: prue.record
      }
      auxTiempos.push(aux);
    })
  }
  return auxTiempos;
}

export async function traerCategorias(pruebas, setNadadoresCarriles, deportistas, torneoEspecifico){
  const auxDeportistas = [];
  const auxPruebas = []
  pruebas.forEach((prue)=>{
    prue.forEach((pru)=>{
      auxPruebas.push(pru);
    })
  })
  auxPruebas.forEach((auxPrue)=>{
    if(auxPrue.genero === 'Mixto'){
      const auxDeportista = deportistas.filter((deport)=>{
        return (deport.pruebas.includes(auxPrue.prueba.id) &&
        (deport.edad >= parseInt(auxPrue.edadInicio) && 
        deport.edad <= parseInt(auxPrue.edadFin)))
      })
      if(auxDeportista.length !== 0){
        auxPrue.deportistas = [...auxDeportista];
      }
    }else{
      const auxDeportista = deportistas.filter((deport)=>{
        return (deport.pruebas.includes(auxPrue.prueba.id) && 
        deport.genero === auxPrue.genero &&
        (deport.edad >= parseInt(auxPrue.edadInicio) && 
        deport.edad <= parseInt(auxPrue.edadFin)))
      })
      if(auxDeportista.length !== 0){
        auxPrue.deportistas = [...auxDeportista];
      }
    }
  })
  auxPruebas.forEach(async(prue)=>{
    auxDeportistas.push(ensayoNadadores(prue.deportistas, torneoEspecifico, prue.prueba.id, prue.categoriaDeportistas));
  })
  setNadadoresCarriles(auxDeportistas);
}

//operacion para sacar las series necesarias.
function ensayoNadadores(nadadores, torneoEspecifico, idPrueba, categoria){
  
  const carrilInicio = parseInt(torneoEspecifico.carrilInicio);
  const carril = parseInt(torneoEspecifico.carril);
  const modoSeries = torneoEspecifico.series;
  const dividirNSeries = nadadores.length/carril;
  const nSeriesEnsayo = sacarNseriesEnsayo(dividirNSeries);
  const nSeries = sacarNseriesEnsayo(dividirNSeries).length;
  const carriles = organizarNadadores(nadadores, nSeries, carril, idPrueba, modoSeries, categoria);

  for (let i = nSeries - 1; i >= 0 ; i--) {
    nSeriesEnsayo[i] = {Serie: i + 1, nadadores: []};
    let contadorCarriles = carrilInicio;
    for (let j = 0; j < carriles[i].length; j++) {
      const equipo = carriles[i][j].map((user)=>{return user.equipo});
      const records = carriles[i][j].map((user)=>{return user.records});
      const categoria = carriles[i][j].map((user)=>{return user.categoria});
      const genero = carriles[i][j].map((user)=>{return user.genero});
      const fechaNacimiento = carriles[i][j].map((user)=>{return user.fechaNacimiento});
      const codePais = carriles[i][j].map((user)=>{return user.codePais});
      const departamento = carriles[i][j].map((user)=>{return user.departamento});
      const verificado = carriles[i][j].map((user)=>{return user.verificado});
      const urlPhoto = carriles[i][j].map((user)=>{return user.urlPhoto});
      const urlPhotoEq = carriles[i][j].map((user)=>{return user.urlPhotoEq});
      if(equipo[0]){
        const edades = carriles[i][j].map((user)=>{return user.edades});
        const ocultar = carriles[i][j].map((user)=>{return user.ocultar});
        nSeriesEnsayo[i].nadadores.push({
          carril: contadorCarriles,
          nombre: carriles[i][j].map((user)=>{return user.nombre}), 
          club: carriles[i][j].map((user)=>{return user.club}), 
          identificacion: carriles[i][j].map((user)=>{return user.identificacion}), 
          nombreclub: carriles[i][j].map((user)=>{return user.nombreclub}), 
          edad: carriles[i][j].map((user)=>{return user.edad}), 
          categoria: categoria[0] ? categoria[0] : [], 
          records: records[0] ? records[0] : [], 
          equipo: equipo[0], 
          edades: edades[0],
          genero: genero[0] ? genero[0] : [],
          fechaNacimiento: fechaNacimiento[0] ? fechaNacimiento[0] : [],
          codePais: codePais[0] ? codePais[0] : [],
          departamento: departamento[0] ? departamento[0] : [],
          ocultar: ocultar[0],
        });
      }else{
        nSeriesEnsayo[i].nadadores.push({
          carril: contadorCarriles,
          nombre: carriles[i][j].map((user)=>{return user.nombre}), 
          club: carriles[i][j].map((user)=>{return user.club}), 
          identificacion: carriles[i][j].map((user)=>{return user.identificacion}), 
          nombreclub: carriles[i][j].map((user)=>{return user.nombreclub}), 
          edad: carriles[i][j].map((user)=>{return user.edad}), 
          categoria: categoria[0] ? categoria[0] : [], 
          records: records[0] ? records[0] : [],
          genero: genero[0] ? genero[0] : [],
          fechaNacimiento: fechaNacimiento[0] ? fechaNacimiento[0] : [],
          codePais: codePais[0] ? codePais[0] : [],
          departamento: departamento[0] ? departamento[0] : [],
          verificado: verificado[0] ? verificado[0] : [],
          urlPhoto: urlPhoto[0] ? urlPhoto[0] : [],
          urlPhotoEq: urlPhotoEq[0] ? urlPhotoEq[0] : [],
        });
      }
      contadorCarriles++;
    }
  }
  return nSeriesEnsayo;
}

//operacion para calcular el numero de series que salen en cada categoria
function sacarNseriesEnsayo(n){
  const nSeries = [];
  if(n % 1 === 0){
    for (let i = 0; i < Math.floor(n); i++) {
      nSeries.push({});
    }
  }else{
    for (let i = 0; i < Math.floor(n) + 1; i++) {
      nSeries.push({});
    }
  }
  return nSeries;
}

function organizarDeportistasAbierta(carril, nadadores, idPrueba) {
  const nCarriles = carril;

  const tiempoToSeconds = t => {
    if (!t || t === '0:0:0') return Infinity;
    const [min = 0, sec = 0, ms = 0] = t.split(':').map(Number);
    return min * 60 + sec + ms / 100;
  };

  // filtrar solo los que tienen registro para la prueba
  const lista = nadadores.filter(n => n.records.some(r => r.prueba === idPrueba));
  if (lista.length === 0) return [];

  // 1) ordenar por edad para que los bloques de series queden de menor a mayor edad
  lista.sort((a, b) => {
    const edadA = parseInt(a.edad) || 0;
    const edadB = parseInt(b.edad) || 0;
    if (edadA !== edadB) return edadA - edadB;
    const ta = a.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
    const tb = b.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
    return tiempoToSeconds(ta) - tiempoToSeconds(tb);
  });

  // 2) calcular cuántas series necesitamos y repartir tamaños de forma equilibrada
  const total = lista.length;
  const seriesCount = Math.max(1, Math.ceil(total / nCarriles));
  const base = Math.floor(total / seriesCount);
  const extra = total % seriesCount;
  const targetSizes = Array.from({ length: seriesCount }, (_v, index) => base + (index >= seriesCount - extra ? 1 : 0));

  // 3) segmentar por edad en bloques contiguos, con las series más pequeñas primero
  const series = [];
  let offset = 0;

  targetSizes.forEach(size => {
    series.push(lista.slice(offset, offset + size));
    offset += size;
  });

  // 3.5) distribuir equitativamente deportistas del mismo club entre series de la misma edad
  // ej: Tiburones Blancos con 6 niños edad 13 en 2 series → distribuir 3-3
  const maxIteraciones = 500;
  for (let iterGlobal = 0; iterGlobal < maxIteraciones; iterGlobal++) {
    let seRealizo = false;

    // iterar sobre edades únicas
    const edadesUnicas = new Set();
    series.forEach(s => s.forEach(n => edadesUnicas.add(parseInt(n.edad) || 0)));

    edadesUnicas.forEach(edad => {
      // encontrar series que contienen esta edad
      const seriesConEdad = [];
      for (let s = 0; s < series.length; s++) {
        if (series[s].some(n => (parseInt(n.edad) || 0) === edad)) {
          seriesConEdad.push(s);
        }
      }

      if (seriesConEdad.length <= 1) return; // solo una serie con esta edad, nada que distribuir

      // encontrar clubs que aparecen en esta edad
      const clubesEnEdad = new Set();
      seriesConEdad.forEach(s => {
        series[s].forEach(n => {
          if ((parseInt(n.edad) || 0) === edad) {
            clubesEnEdad.add(n.nombreclub);
          }
        });
      });

      // para cada club, intentar distribuir equitativamente
      clubesEnEdad.forEach(club => {
        // contar cuántos del club hay en cada serie
        const countPorSerie = {};
        seriesConEdad.forEach(s => {
          countPorSerie[s] = series[s].filter(
            n => (parseInt(n.edad) || 0) === edad && n.nombreclub === club
          ).length;
        });

        const total = Object.values(countPorSerie).reduce((a, b) => a + b, 0);
        if (total <= 1) return; // 0 o 1, no hay que distribuir

        // calcular distribución objetivo
        const base = Math.floor(total / seriesConEdad.length);
        const exceso = total % seriesConEdad.length;
        const metas = seriesConEdad.map((_, idx) => base + (idx < exceso ? 1 : 0));

        // buscar serie con exceso y serie con déficit
        let serieExceso = -1;
        let serieDeficit = -1;

        for (let i = 0; i < seriesConEdad.length; i++) {
          const s = seriesConEdad[i];
          const actual = countPorSerie[s];
          const meta = metas[i];

          if (actual > meta && serieExceso === -1) {
            serieExceso = s;
          }
          if (actual < meta && serieDeficit === -1) {
            serieDeficit = s;
          }
        }

        // si hay exceso y déficit, hacer intercambio
        if (serieExceso !== -1 && serieDeficit !== -1) {
          // encontrar nadador del club en serieExceso
          const idxExceso = series[serieExceso].findIndex(
            n => (parseInt(n.edad) || 0) === edad && n.nombreclub === club
          );

          // encontrar nadador de distinto club en serieDeficit con misma edad
          const idxDeficit = series[serieDeficit].findIndex(
            n => (parseInt(n.edad) || 0) === edad && n.nombreclub !== club
          );

          if (idxExceso !== -1 && idxDeficit !== -1) {
            // intercambiar
            [series[serieExceso][idxExceso], series[serieDeficit][idxDeficit]] = [
              series[serieDeficit][idxDeficit],
              series[serieExceso][idxExceso]
            ];
            seRealizo = true;
          }
        }
      });
    });

    if (!seRealizo) break; // sin cambios, algoritmo converge
  }

  // 4) ordenar cada serie por tiempo para mantener la lógica de marcas dentro de edades similares
  const seriesOrdenadas = series.map(serie => {
    return serie.sort((a, b) => {
      const edadA = parseInt(a.edad) || 0;
      const edadB = parseInt(b.edad) || 0;
      if (edadA !== edadB) return edadA - edadB;
      const ta = a.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
      const tb = b.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
      return tiempoToSeconds(ta) - tiempoToSeconds(tb);
    });
  });

  // 5) ordenar las series por edad promedio ascendente para que la serie 1 sea la más joven
  seriesOrdenadas.sort((a, b) => {
    const avgAge = serie => serie.reduce((sum, n) => sum + (parseInt(n.edad) || 0), 0) / Math.max(1, serie.length);
    return avgAge(a) - avgAge(b);
  });

  // 6) asignar carriles dentro de cada serie (colocar los nadadores mejor registrados en los carriles centrales)
  return seriesOrdenadas.map(serie => {

  // separar nadadores con tiempo y sin tiempo
  const conTiempo = [];
  const sinTiempo = [];

  serie.forEach(nadador => {
    const tiempo = nadador.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';

    if (tiempoToSeconds(tiempo) === Infinity) {
      sinTiempo.push(nadador);
    } else {
      conTiempo.push(nadador);
    }
  });

  // ordenar SOLO los que tienen tiempo
  conTiempo.sort((a, b) => {
    const ta = a.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
    const tb = b.records.find(r => r.prueba === idPrueba)?.record || '0:0:0';
    return tiempoToSeconds(ta) - tiempoToSeconds(tb);
  });

  const carriles = Array.from({ length: nCarriles }, () => null);

  // patrón centro → afuera
  const ordenCarriles = [];
  const centro = Math.floor(nCarriles / 2);

  ordenCarriles.push(centro);

  for (let offset = 1; offset < nCarriles; offset++) {
    if (centro - offset >= 0) ordenCarriles.push(centro - offset);
    if (centro + offset < nCarriles) ordenCarriles.push(centro + offset);
  }

  // colocar primero los que tienen tiempo
  conTiempo.forEach((nadador, idx) => {
    if (idx < ordenCarriles.length) {
      carriles[ordenCarriles[idx]] = nadador;
    }
  });

  // carriles libres respetando el orden centro → afuera
const carrilesLibres = ordenCarriles.filter(idx => carriles[idx] === null);

// mezclar solamente los nadadores sin tiempo
for (let i = sinTiempo.length - 1; i > 0; i--) {
  const j = Math.floor(Math.random() * (i + 1));
  [sinTiempo[i], sinTiempo[j]] = [sinTiempo[j], sinTiempo[i]];
}

// asignar en los carriles libres desde el centro hacia afuera
sinTiempo.forEach((nadador, idx) => {
  if (idx < carrilesLibres.length) {
    carriles[carrilesLibres[idx]] = nadador;
  }
});

  // devolver formato original
  return carriles.map(n => n ? [n] : []);
});
}

//operacion para organizar los nadadores.
function organizarNadadores(nadadores, nSeries, carril, idPrueba, modoSeries, categoria) {
  if(modoSeries === 'rapidas'){
    if(categoria !== 'master'){
      const nCarriles = carril;
  
      // Filtrar y ordenar nadadores con tiempo registrado (de menor a mayor tiempo)
      const nadadoresConTiempo = nadadores
      .filter(nadador =>
          nadador.records.some(record => record.prueba === idPrueba && record.record !== '0:0:0')
      )
      .sort((a, b) => {
          const tiempoA = a.records.find(record => record.prueba === idPrueba)?.record;
          const tiempoB = b.records.find(record => record.prueba === idPrueba)?.record;
          return tiempoToSeconds(tiempoA) - tiempoToSeconds(tiempoB);
      });
  
      // Filtrar nadadores sin tiempo registrado y mezclarlos aleatoriamente
      const nadadoresSinTiempo = nadadores
      .filter(nadador =>
          nadador.records.every(record => record.prueba !== idPrueba || record.record === '0:0:0')
      )
      .sort(() => Math.random() - 0.5); // Mezclar aleatoriamente
  
      // Unir listas: primero los nadadores con tiempo, luego los sin tiempo
      const nadadoresOrdenados = nadadoresConTiempo.concat(nadadoresSinTiempo);
  
      // Distribuir los nadadores de manera equitativa en las series
      const totalNadadores = nadadoresOrdenados.length;
      const basePorSerie = Math.floor(totalNadadores / nSeries); // Nadadores mínimos por serie
      let extras = totalNadadores % nSeries; // Nadadores sobrantes que se distribuyen
  
      const series = Array.from({ length: nSeries }, () => []);
      
      let index = 0;
      for (let i = 0; i < nSeries; i++) {
        const cantidadEnSerie = basePorSerie + (extras > 0 ? 1 : 0);
        extras--;
        for (let j = 0; j < cantidadEnSerie; j++) {
          if (index < totalNadadores) {
            series[i].push(nadadoresOrdenados[index]);
            index++;
          }
        }
      }
  
      // Invertir las series para que los más rápidos queden en la última serie
      series.reverse();
  
      // Organizar carriles dentro de cada serie (colocar nadadores en carriles centrales primero)
      const carriles = series.map(serie => {
        const centralCarril = Math.floor(nCarriles / 2);
        const serieCarriles = Array.from({ length: nCarriles }, () => []);
  
        let offset = 0;
        serie.forEach(nadador => {
          let carrilIndex;
          if (offset % 2 === 0) {
            carrilIndex = centralCarril + offset / 2;
          } else {
            carrilIndex = centralCarril - (offset + 1) / 2;
          }
          offset++;
          // Asignar nadador al carril correspondiente
          serieCarriles[carrilIndex].push(nadador);
        });
  
        return serieCarriles;
      });
  
      return carriles;
    }else{
      return organizarDeportistasAbierta(carril, nadadores, idPrueba);
    }
  }else{
    if(categoria !== 'master' && !categoria.includes("abierta")){
      const nCarriles = carril;
  
      // Filtrar los nadadores que tienen tiempos registrados para la prueba
      const nadadoresConTiempo = nadadores.filter(nadador =>
        nadador.records.some(record => record.prueba === idPrueba && record.record !== '0:0:0')
      );
    
      // Ordenar los nadadores por tiempo si tienen tiempo registrado
      nadadoresConTiempo.sort((a, b) => {
        const tiempoA = a.records.find(record => record.prueba === idPrueba)?.record;
        const tiempoB = b.records.find(record => record.prueba === idPrueba)?.record;
        return tiempoToSeconds(tiempoA) - tiempoToSeconds(tiempoB);
      });
    
      // Filtrar los nadadores sin tiempo
      const nadadoresSinTiempo = nadadores.filter(nadador =>
        nadador.records.every(record => record.prueba !== idPrueba || record.record === '0:0:0')
      );
    
      // Mezclar los nadadores con tiempo y los de tiempo 0
      const nadadoresMezclados = nadadoresConTiempo.concat(nadadoresSinTiempo);
    
      // Distribuir los nadadores de cada club entre las series de forma equitativa
      const clubes = {};
      nadadoresMezclados.forEach(nadador => {
        if (!clubes[nadador.nombreclub]) {
          clubes[nadador.nombreclub] = [];
        }
        clubes[nadador.nombreclub].push(nadador);
      });
    
      // Distribuir los nadadores de cada club en series separadas
      const seriesPorClub = Object.values(clubes);
      const series = Array.from({ length: nSeries }, () => []);
      let serieIndex = 0;
      seriesPorClub.forEach(club => {
        club.forEach(nadador => {
          series[serieIndex % nSeries].push(nadador);
          serieIndex++;
        });
      });
    
      // Mezclar las series para evitar que los nadadores del mismo club estén en la misma serie
      series.forEach(serie => {
        serie.sort(() => Math.random() - 0.5);
      });
    
      // Distribuir los nadadores de cada serie en los carriles, colocando primero a los más rápidos en los carriles centrales
      const carriles = Array.from({ length: nSeries }, () =>
        Array.from({ length: nCarriles }, () => [])
      );
    
      series.forEach((serie, serieIndex) => {
        // Filtrar los nadadores con tiempo en la serie actual
        const nadadoresConTiempoEnSerie = serie.filter(nadador =>
          nadador.records.some(record => record.prueba === idPrueba && record.record !== '0:0:0')
        );
      
        // Ordenar los nadadores con tiempo por tiempo de menor a mayor
        nadadoresConTiempoEnSerie.sort((a, b) => {
          const tiempoA = a.records.find(record => record.prueba === idPrueba)?.record;
          const tiempoB = b.records.find(record => record.prueba === idPrueba)?.record;
          return tiempoToSeconds(tiempoA) - tiempoToSeconds(tiempoB);
        });
      
        const centralCarril = Math.floor(nCarriles / 2);
        let offset = 0;
      
        // Colocar a los nadadores en los carriles centrales, expandiéndose hacia los laterales
        nadadoresConTiempoEnSerie.forEach(nadador => {
          let carrilIndex;
        
          if (offset % 2 === 0) {
            carrilIndex = centralCarril + offset / 2;
          } else {
            carrilIndex = centralCarril - (offset + 1) / 2;
          }
        
          offset++;
        
          // Asegurarse de no exceder el límite de nadadores en un carril
          while (
            carriles[serieIndex][carrilIndex].length >= Math.ceil(serie.length / nCarriles) ||
            carriles[serieIndex][carrilIndex].some(n => n.nombreclub === nadador.nombreclub)
          ) {
            carrilIndex = (carrilIndex + 1) % nCarriles; // Mover al siguiente carril
          }
        
          carriles[serieIndex][carrilIndex].push(nadador);
        });
      
        // Colocar a los nadadores sin tiempo en los carriles centrales
        const nadadoresSinTiempoEnSerie = serie.filter(nadador =>
          nadador.records.every(record => record.prueba !== idPrueba || record.record === '0:0:0')
        );
      
        nadadoresSinTiempoEnSerie.forEach(nadador => {
          let carrilIndex;
        
          if (offset % 2 === 0) {
            carrilIndex = centralCarril + offset / 2;
          } else {
            carrilIndex = centralCarril - (offset + 1) / 2;
          }
        
          offset++;
        
          // Asegurarse de no exceder el límite de nadadores en un carril
          while (
            carriles[serieIndex][carrilIndex].length >= Math.ceil(serie.length / nCarriles) ||
            carriles[serieIndex][carrilIndex].some(n => n.nombreclub === nadador.nombreclub)
          ) {
            carrilIndex = (carrilIndex + 1) % nCarriles; // Mover al siguiente carril
          }
        
          carriles[serieIndex][carrilIndex].push(nadador);
        });
      });
    
      return carriles.reverse();
    }else{
      return organizarDeportistasAbierta(carril, nadadores, idPrueba);
    }
  }
}

// Función auxiliar para convertir tiempo en formato 'HH:MM:SS' a segundos
function tiempoToSeconds(tiempo) {
  const [horas, minutos, segundos] = tiempo.split(':').map(Number);
  return horas * 3600 + minutos * 60 + segundos;
}

// ------------------ fin configuracion del la automatizacion de planillas ----------------------
//------------------- configuracion de datos locales -----------------------------
export async function abrirBaseDeDatosLocal(id){
  if(id !== ''){
    const dbTiempos = await openDB(id, 1, {
      upgrade(dbTiempos) {
        dbTiempos.createObjectStore('resultados', { keyPath: 'id', autoIncrement: true });
      },
    });
  }
};

async function agregarTiempoLocal(prueba, id) {
  if(id !== ''){
    const db = await openDB(id, 1);
    const datoExistente = await verificarResultadosTiemposLocalesExistente(db, 'resultados', prueba.id);
    const tx = db.transaction('resultados', 'readwrite');
    const store = tx.objectStore('resultados');
    if(datoExistente){
      store.put(prueba);
    }else{
      store.add(prueba);
    }
    await tx.done;
  }
}

async function verificarResultadosTiemposLocalesExistente(db, almacenamiento, clave) {
  const tx = db.transaction(almacenamiento);
  const store = tx.objectStore(almacenamiento);
  return await store.get(clave);
}

async function recuperarResultadosTiemposLocales(db, id) {
  const tx = db.transaction(id);
  const store = tx.objectStore(id);
  const datos = await store.getAll();
  return datos;
}

export async function backupTiemposLocales(id, setBackup) {
  if(id !== ''){
    const db = await openDB(id, 1);
    const tx = db.transaction('resultados');
    const store = tx.objectStore('resultados');
    const datos = await store.getAll();
    setBackup(datos);
  }
}

async function eliminarBaseDeDatosLocal(id){
  const toastId = toast.loading('Eliminando tiempos en cache para guardar nuevos tiempos...');
  deleteDB(id).then(()=>{
    toast.dismiss(toastId);
    toast.success('Tiempos Eliminados con exito.');
  })
}
//------------------- fin configuracion de datos locales -----------------------------
// ------------------ configuracion de los tiempos -----------------------------
//verificar y limpiar el almacenamiento local
let contadorMensajeBDLocal = 0;
export async function verificarLimpiar(id) {
  if(id !== ''){
    const db = await openDB(id, 1);
    const auxResultadosLocal = await recuperarResultadosTiemposLocales(db, 'resultados');
    const docRef = collection(firestore, `TorneosTemporales/${id}/tiempos`);
    const auxResultados = await getDocs(docRef);
    var condition = navigator.onLine ? 'online' : 'offline';
    if (condition === 'online') {
      fetch('https://www.google.com/', { // Check for internet connectivity
        mode: 'no-cors',
      }).then(() => {
        if(auxResultadosLocal.length !== 0 && auxResultados.empty && contadorMensajeBDLocal === 0){
          contadorMensajeBDLocal++;
          eliminarBaseDeDatosLocal(id);
        }
      })
    }
  }
}

//tiempos Registrar
export async function registrarTiempos(id, idTiempo, prueba, auxTiemposRegistrados){
  const auxPrueba = {
    categoria: prueba.categoria, 
    id: prueba.id, 
    nadadores: prueba.nadadores, 
    prueba: prueba.prueba, 
    seriesRegistradas: auxTiemposRegistrados[prueba.id]
  }
  try {
    const docRef = doc(firestore, `TorneosTemporales/${id}/tiempos/${idTiempo}`);
    const docSnap = await getDoc(docRef)
    if(!docSnap.exists()){
      setDoc(docRef, prueba);
      toast.success('Tiempos registrados correctamente.')
    }else{
      updateDoc(docRef, prueba);
      toast.success('Tiempos actualizados correctamente.')
    }
    agregarTiempoLocal(auxPrueba, id);
  } catch (error) {
    agregarTiempoLocal(auxPrueba, id);
    toast.error('Sin conexión.')
    toast.success('Tiempos actualizados correctamente en el almacenamiento local.')
  }
}

//operacion para traer las tablas de cada prueba
let unsubscribePlanillas = null;

export async function traerTablasPlanilla(id, setNadadoresCarriles, idPlanilla){
  const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${idPlanilla}`);
  unsubscribePlanillas = onSnapshot(docRef, (docSnap) => {
    if(docSnap.exists){
      setNadadoresCarriles(docSnap.data().planilla);
    }else{
      setNadadoresCarriles([]);
    }
  });
}

// Función para cancelar la suscripción
export function cancelarSuscripcionPlanillas() {
  if (unsubscribePlanillas) {
    unsubscribePlanillas();
    unsubscribePlanillas = null;
  }
}

//operacion para traer los resultados en tiempo real.
let unsubscribeTiempos = null;

export async function traerResultados(id, setResultados, setConexion, nombreclub){
  if(id !== ''){
    let db;
    let auxResultados;
    if(nombreclub === datosAdmin.nombre || nombreclub === 'PROWEBSPORTS'){
      db = await openDB(id, 1);
      auxResultados = await recuperarResultadosTiemposLocales(db, 'resultados');
    }
    const tiemposCollectionRef = collection(firestore, `TorneosTemporales/${id}/tiempos`);
    
    unsubscribeTiempos = onSnapshot(tiemposCollectionRef, (querySnapshot) => {
      const resultados = querySnapshot.docs
        .filter((doc) => doc.exists)
        .map((doc) => doc.data())
        .sort((a, b) => a.id - b.id);
  
        if(nombreclub === datosAdmin.nombre || nombreclub === 'PROWEBSPORTS'){
          if(resultados.length < auxResultados.length){
            setConexion(false);
            auxResultados.sort((a, b) => a.id - b.id);
            setResultados(auxResultados);
          }else{
            setConexion(true);
            setResultados(resultados);
          }
        }else{
          setResultados(resultados);
        }
    }, (error) =>{
      if(nombreclub === datosAdmin.nombre || nombreclub === 'PROWEBSPORTS'){
        setConexion(false);
        auxResultados.sort((a, b) => a.id - b.id);
        setResultados(auxResultados);
      }
    });
  }
}

export function cancelarTiemposResultados(){
  if (unsubscribeTiempos) {
    unsubscribeTiempos();
    unsubscribeTiempos = null;
  }
}

export function eliminarResultados(idTorneo, idResultados){
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}/tiempos/${idResultados}`);
  const docRefFamilia = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/tiempos/${idResultados}`);
  deleteDoc(docRef);
  deleteDoc(docRefFamilia);
}

// ------------------ fin configuracion de los tiempos ----------------------------
// ------------------ configuracion ranking -----------------------------
//esta funcion nos ayudara a registrar todos los nadadores y asi tener un registro general de ellos.
export async function registrarDeportistaGeneral(id, deport, departamento){
  const docRef = doc(firestoreRankingPws, `ranking/${id}`);
  const docSnap = await getDoc(docRef);
  let hoy = new Date();
  let cumple = !docSnap.exists() ? deport.fechaNacimiento.split('-') : docSnap.data().verificado === 'Verificado' ? docSnap.data().fechaNacimiento.split('-') : deport.fechaNacimiento.split('-');
  let cumpleanosAno = parseInt(cumple[0]);
  let edad = hoy.getFullYear() - cumpleanosAno;

  if(!docSnap.exists()){
    const auxNadador = {
      club: deport.nombreclub,
      nombre: deport.nombre,
      identificacion: deport.identificacion,
      fechaNacimiento: deport.fechaNacimiento,
      edad: edad + '',
      genero: deport.genero,
      departamento,
      pruebas: [],
      verificado: deport.verificado
    }
    setDoc(docRef, auxNadador);
    toast.success('Deportista registrado en el ranking de PROWEBSPORTS correctamente.');
  }else{
    updateDoc(docRef, {
      fechaNacimiento: docSnap.data().verificado === 'Verificado' ? docSnap.data().fechaNacimiento : deport.fechaNacimiento, 
      edad: edad + '',
      genero: deport.genero,
      verificado: docSnap.data().verificado === 'Verificado' ? 'Verificado' : deport.verificado
    });
  }
}

export async function actualizarVerificacion(id, deportInsc, deportDoc){
  const docRef = doc(firestoreRankingPws, `ranking/${id}`);
  const docSnap = await getDoc(docRef);
  if(docSnap.exists()){
    let valido = true;
    if(deportInsc.identificacion !== deportDoc.numeroIdentificacion || docSnap.data().identificacion !== deportDoc.numeroIdentificacion){
      valido = false;
      toast.error('¡Ups! La identificación no coinciden.');
      throw new Error("IDENTIFICACION NO COINCIDE");
    }
    if(deportInsc.fechaNacimiento !== deportDoc.fechaNacimiento || docSnap.data().fechaNacimiento !== deportDoc.fechaNacimiento){
      valido = false;
      toast.error('¡Ups! La fecha de nacimiento no coinciden.');
      throw new Error("FECHA DE NACIMIENTO NO COINCIDE");
    }

    if(docSnap.data().verificado === 'Verificado'){
      valido = false;
      throw new Error("DEPORTISTA YA VERIFICADO");
    }

    if(valido){
      updateDoc(docRef, {
        verificado: 'Verificado'
      });
    }
  }
}

function pruebasEstablecidasRanking(){
  const auxPruebas = [
    '25 Libre',
    '50 Libre',
    '100 Libre',
    '200 Libre',
    '400 Libre',
    '800 Libre',
    '1500 Libre',

    '25 Espalda',
    '50 Espalda',
    '100 Espalda',
    '200 Espalda',

    '25 Pecho',
    '50 Pecho',
    '100 Pecho',
    '200 Pecho',

    '25 Mariposa',
    '50 Mariposa',
    '100 Mariposa',
    '200 Mariposa',

    '100 Combinado Ind.',
    '200 Combinado Ind.',
    '400 Combinado Ind.',
  ];

  return auxPruebas;
}

//funcion para ir registrando los records y asi poder mostrar el mejoramiento de los nadadores en el ranking de prowebsports.
export async function registrarRecordsPws(id, prueba, tiempo, recordActual, posicion, nCarriles, distanciaPiscina){
  const pruebaEncontrada = pruebasEstablecidasRanking().filter((prue)=>{return prue === prueba.prueba})
  if(pruebaEncontrada.length !== 0){
    const docRef = doc(firestoreRankingPws, `ranking/${id}`);
    const docSnap = await getDoc(docRef);
    if(docSnap.exists()){
      const fechaTorneo = new Date();
      const dia = fechaTorneo.getDate();
      const mes = fechaTorneo.getMonth() + 1;
      const anio = fechaTorneo.getFullYear();
      const fecha = anio + '-' + String(mes).padStart(2, '0') + '-' + String(dia).padStart(2, '0');
      const auxRecords = {
        fecha,
        prueba: prueba.prueba,
        tiempo,
        record: tiempo,
        pg: tiempo === '0:0:0' ? '0' : parseInt(nCarriles) === 10 ? puntosEstablecidos10CarrilesFecna(0, posicion) : puntosEstablecidos8CarrilesFecna(0, posicion),
        pa: '0',
        piscina: distanciaPiscina
      }
    
      const recordsGuardados = docSnap.data().pruebas.filter((rec) => {return (rec.prueba === prueba.prueba && rec.piscina !== distanciaPiscina) || (rec.prueba !== prueba.prueba && (rec.piscina !== distanciaPiscina || rec.piscina === distanciaPiscina))});
      const recordsAntiguo = docSnap.data().pruebas.filter((rec) => {return rec.prueba === prueba.prueba && rec.piscina === distanciaPiscina});
        
      let records = [];
      if(recordsAntiguo.length !== 0){
        if(recordsAntiguo[0].fecha === fecha){
          const restarPuntos = parseInt(recordsAntiguo[0].pa - recordsAntiguo[0].pg);
          if(parseInt(nCarriles) === 10){
            auxRecords.pa = parseInt(puntosEstablecidos10CarrilesFecna(restarPuntos, posicion)) >= 0 ? puntosEstablecidos10CarrilesFecna(restarPuntos, posicion) : recordsAntiguo[0].pg;
          }
          if(parseInt(nCarriles) <= 8){
            auxRecords.pa = parseInt(puntosEstablecidos8CarrilesFecna(restarPuntos, posicion)) >= 0 ? puntosEstablecidos8CarrilesFecna(restarPuntos, posicion) : recordsAntiguo[0].pg;
          }
        }else{
          if(parseInt(nCarriles) === 10){
            auxRecords.pa = puntosEstablecidos10CarrilesFecna(parseInt(recordsAntiguo[0].pa), posicion);
          }
          if(parseInt(nCarriles) <= 8){
            auxRecords.pa = puntosEstablecidos8CarrilesFecna(parseInt(recordsAntiguo[0].pa), posicion);
          }
        }
    
        const dividirTiempoA = recordActual.split(':');
        const dividirTiempoB = tiempo.split(':');
        const tiempoMinA = dividirTiempoA[0];
        const tiempoSegA = dividirTiempoA[1];
        const tiempoMiliA = dividirTiempoA[2];
        const tiempoMinB = dividirTiempoB[0];
        const tiempoSegB = dividirTiempoB[1];
        const tiempoMiliB = dividirTiempoB[2];
        const tiempoA = parseInt(tiempoMinA) * 60 * 1000 + parseInt(tiempoSegA) * 1000 + parseInt(tiempoMiliA);
        const tiempoB = parseInt(tiempoMinB) * 60 * 1000 + parseInt(tiempoSegB) * 1000 + parseInt(tiempoMiliB);
        
        if(tiempoA <= tiempoB){
          if(recordActual === '0:0:0'){
            auxRecords.record = tiempo;
          }else{
            auxRecords.record = recordActual;
          }
          records = [auxRecords, ...recordsGuardados];
        }else{
          if(tiempo === '0:0:0'){
            auxRecords.record = recordActual;
          }
          records = [auxRecords, ...recordsGuardados];
        }
      }else{
        if(parseInt(nCarriles) === 10){
          auxRecords.pa = puntosEstablecidos10CarrilesFecna(0, posicion);
        }
        if(parseInt(nCarriles) <= 8){
          auxRecords.pa = puntosEstablecidos8CarrilesFecna(0, posicion);
        }
        records = [auxRecords, ...recordsGuardados];
      }
  
      if(tiempo !== '61:0:0' && (distanciaPiscina === '25' || distanciaPiscina === '50')){
        updateDoc(docRef, {
          pruebas: records
        })
      }
    }
  }
}

export function puntosEstablecidos8CarrilesFecna(puntos, posicion){
  let auxPuntos = '0';
  switch (posicion) {
    case 0:
      auxPuntos = `${puntos + 18}`
      break;
    case 1:
      auxPuntos = `${puntos + 16}`
      break;
    case 2:
      auxPuntos = `${puntos + 15}`
      break;
    case 3:
      auxPuntos = `${puntos + 14}`
      break;
    case 4:
      auxPuntos = `${puntos + 13}`
      break;
    case 5:
      auxPuntos = `${puntos + 12}`
      break;
    case 6:
      auxPuntos = `${puntos + 11}`
      break;
    case 7:
      auxPuntos = `${puntos + 10}`
      break;
    case 8:
      auxPuntos = `${puntos + 8}`
      break;
    case 9:
      auxPuntos = `${puntos + 7}`
      break;
    case 10:
      auxPuntos = `${puntos + 6}`
      break;
    case 11:
      auxPuntos = `${puntos + 5}`
      break;
    case 12:
      auxPuntos = `${puntos + 4}`
      break;
    case 13:
      auxPuntos = `${puntos + 3}`
      break;
    case 14:
      auxPuntos = `${puntos + 2}`
      break;
    case 15:
      auxPuntos = `${puntos + 1}`
      break;
    default:
      break;
  }
  return auxPuntos;
}

export function puntosRelevosEstablecidos8CarrilesFecna(puntos, posicion){
  let auxPuntos = '0';
  switch (posicion) {
    case 0:
      auxPuntos = `${puntos + 36}`
      break;
    case 1:
      auxPuntos = `${puntos + 32}`
      break;
    case 2:
      auxPuntos = `${puntos + 30}`
      break;
    case 3:
      auxPuntos = `${puntos + 28}`
      break;
    case 4:
      auxPuntos = `${puntos + 26}`
      break;
    case 5:
      auxPuntos = `${puntos + 24}`
      break;
    case 6:
      auxPuntos = `${puntos + 22}`
      break;
    case 7:
      auxPuntos = `${puntos + 20}`
      break;
    default:
      break;
  }
  return auxPuntos;
}

export function puntosEstablecidos10CarrilesFecna(puntos, posicion){
  let auxPuntos = '0';
  switch (posicion) {
    case 0:
      auxPuntos = `${puntos + 22}`
      break;
    case 1:
      auxPuntos = `${puntos + 20}`
      break;
    case 2:
      auxPuntos = `${puntos + 19}`
      break;
    case 3:
      auxPuntos = `${puntos + 18}`
      break;
    case 4:
      auxPuntos = `${puntos + 17}`
      break;
    case 5:
      auxPuntos = `${puntos + 16}`
      break;
    case 6:
      auxPuntos = `${puntos + 15}`
      break;
    case 7:
      auxPuntos = `${puntos + 14}`
      break;
    case 8:
      auxPuntos = `${puntos + 13}`
      break;
    case 9:
      auxPuntos = `${puntos + 12}`
      break;
    case 10:
      auxPuntos = `${puntos + 10}`
      break;
    case 11:
      auxPuntos = `${puntos + 9}`
      break;
    case 12:
      auxPuntos = `${puntos + 8}`
      break;
    case 13:
      auxPuntos = `${puntos + 7}`
      break;
    case 14:
      auxPuntos = `${puntos + 6}`
      break;
    case 15:
      auxPuntos = `${puntos + 5}`
      break;
    case 16:
      auxPuntos = `${puntos + 4}`
      break;
    case 17:
      auxPuntos = `${puntos + 3}`
      break;
    case 18:
      auxPuntos = `${puntos + 2}`
      break;
    case 19:
      auxPuntos = `${puntos + 1}`
      break;
    default:
      break;
  }
  return auxPuntos;
}

export function puntosRelevosEstablecidos10CarrilesFecna(puntos, posicion){
  let auxPuntos = '0';
  switch (posicion) {
    case 0:
      auxPuntos = `${puntos + 40}`
      break;
    case 1:
      auxPuntos = `${puntos + 36}`
      break;
    case 2:
      auxPuntos = `${puntos + 34}`
      break;
    case 3:
      auxPuntos = `${puntos + 32}`
      break;
    case 4:
      auxPuntos = `${puntos + 30}`
      break;
    case 5:
      auxPuntos = `${puntos + 28}`
      break;
    case 6:
      auxPuntos = `${puntos + 26}`
      break;
    case 7:
      auxPuntos = `${puntos + 24}`
      break;
    case 8:
      auxPuntos = `${puntos + 22}`
      break;
    case 9:
      auxPuntos = `${puntos + 20}`
      break;
    default:
      break;
  }
  return auxPuntos;
}

function rangoEdades(edad, auxNadadores, nad, edadI, edadFin){
  if(edad >= edadI && edad <= edadFin){
    if (!auxNadadores[`${edadI} - ${edadFin}`]) {
      auxNadadores[`${edadI} - ${edadFin}`] = [];
    }
    auxNadadores[`${edadI} - ${edadFin}`].push(nad);
  }
}

const parseEdad = (edad) => {
  if (edad.includes('-')) {
    // Si la edad tiene un rango (ej: '20-80'), tomamos el valor menor
    return parseInt(edad.split('-')[1], 10);
  }
  if (edad.includes('y Mas')) {
    // Si la edad tiene un rango (ej: '20-80'), tomamos el valor menor
    return parseInt(edad.split('-')[0], 10);
  }
  // Si es un número único, lo convertimos a entero
  return parseInt(edad, 10);
};

//esta funcion nos ayudara a traer los ranking.
export async function traerRanking(setRanking, setEdadesRanking){
  const docRef = collection(firestoreRankingPws, `ranking`);
  onSnapshot(docRef, (querySnapshot) => {
    const auxRanking = querySnapshot.docs
        .filter((doc) => doc.exists)
        .map((doc) => doc.data());

    const auxNadadores = {};
    auxRanking.forEach((nad)=>{
      const edad = parseInt(nad.edad);
      if(edad >= 5 && edad <= 18){
        if (!auxNadadores[edad]) {
            auxNadadores[edad] = [];
        }
        auxNadadores[edad].push(nad);
      }
      rangoEdades(edad, auxNadadores, nad, 19, 24);
      rangoEdades(edad, auxNadadores, nad, 25, 29);
      rangoEdades(edad, auxNadadores, nad, 30, 34);
      rangoEdades(edad, auxNadadores, nad, 35, 39);
      rangoEdades(edad, auxNadadores, nad, 40, 44);
      rangoEdades(edad, auxNadadores, nad, 45, 49);
      rangoEdades(edad, auxNadadores, nad, 50, 54);
      rangoEdades(edad, auxNadadores, nad, 55, 59);
      rangoEdades(edad, auxNadadores, nad, 60, 64);
      rangoEdades(edad, auxNadadores, nad, 65, 69);
      rangoEdades(edad, auxNadadores, nad, 70, 74);
      rangoEdades(edad, auxNadadores, nad, 75, 79);
      if(edad >= 80){
        if (!auxNadadores['80 y Mas']) {
            auxNadadores['80 y Mas'] = [];
        }
        auxNadadores['80 y Mas'].push(nad);
      }
    })

    const auxEdadesRanking = [];
    Object.keys(auxNadadores).forEach((value, index)=>{
      const objEdadesRanking = {
        edad: value
      }
      auxEdadesRanking.push(objEdadesRanking);
    })
    auxEdadesRanking.sort((a,b)=> parseEdad(a.edad) - parseEdad(b.edad));
    setEdadesRanking(auxEdadesRanking);
    setRanking(auxNadadores);
  })
}

export async function traerDeportistaRanking(nombreclub, setListDeportistaRanking){
  const docRef = collection(firestoreRankingPws, `ranking`);
  const consultarDeportistas = query(docRef, where("club", '==', `${nombreclub}`));
  const queryDeportistas = await getDocs(consultarDeportistas); 
  const auxDeportistas = queryDeportistas.docs.filter((club)=> club.exists).map((club)=> club.data());
  setListDeportistaRanking(auxDeportistas.sort((a,b)=> a.nombre.localeCompare(b.nombre)));
}

//----------------- fin configuracion ranking --------------------
//-------------------- configuracion de fotos y documentos -----------------
export function subirFotoTorneoEditar(file, idTorneo) {
  const nombreFoto = ref(storage, `${file.name}`);
  uploadBytes(nombreFoto, file)
    .then(() => {
      getDownloadURL(nombreFoto)
        .then((url) => {
          const docRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
          try {
            updateDoc(docRef, {image: url});
            toast.success('Tu foto ha sido cargada con éxito.');
          } catch (error) {
            toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
          }
        })
        .catch(() => {
          toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
        });
    })
    .catch(() => {
      toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
    });
}

//funcion para elminar foto de curso
export function eliminarFotoTorneo(setImgCurso, file, idTorneo) {
  const nombreFoto = ref(storage, `${file}`);
  deleteObject(nombreFoto)
    .then(() => {
      setImgCurso();
      eliminarFotoTorneoFirestore(idTorneo);
      toast.success("La foto del torneo ha sido eliminada con éxito.");
    })
    .catch(() => {
      toast.error(
        "Se produjo un error al eliminar la foto, inténtalo de nuevo."
      );
    });
}

//funcion para elminar foto de curso en firestore
export function eliminarFotoTorneoFirestore(idTorneo) {
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  try {
    updateDoc(docRef, {image: ""});
  } catch (error) {
    toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
  }
}

//funcion para subir las convocatorias de torneo
export function subirConvocatoriaTorneo(file, setImgCurso) {
  const nombreFoto = ref(storage, `${file.name}`);
  uploadBytes(nombreFoto, file)
    .then(() => {
      toast.success("La convocatoria ha sido cargada con éxito.");
      getDownloadURL(nombreFoto)
        .then((url) => {
          setImgCurso(url);
        })
        .catch(() => {
          toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
        });
    })
    .catch(() => {
      toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
    });
}

export function subirConvocatoriaTorneoEditar(file, idTorneo) {
  const nombreFoto = ref(storage, `${file.name}`);
  uploadBytes(nombreFoto, file)
    .then(() => {
      getDownloadURL(nombreFoto)
        .then((url) => {
          const docRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
          try {
            updateDoc(docRef, {convocatoria: url});
            toast.success('La convocatoria ha sido cargada con éxito.');
          } catch (error) {
            toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
          }
        })
        .catch(() => {
          toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
        });
    })
    .catch(() => {
      toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
    });
}

export function subirResultadosPdfTorneo(file, idTorneo) {
  const nombreArchivo = ref(storage, `${file.name}`);
  uploadBytes(nombreArchivo, file)
    .then(() => {
      getDownloadURL(nombreArchivo)
        .then((url) => {
          const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}`);
          const docRefTorneo = doc(firestore, `TorneosTemporales/${idTorneo}`);
          try {
            updateDoc(docRef, {urlResultados: url});
            updateDoc(docRefTorneo, {urlResultados: url});
            toast.success('Los resultados han sido cargados con éxito.');
          } catch (error) {
            toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
          }
        })
        .catch(() => {
          toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
        });
    })
    .catch(() => {
      toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
    });
}

export function subirProgramacionPdfTorneo(file, idTorneo) {
  const nombreArchivo = ref(storage, `${file.name}`);
  uploadBytes(nombreArchivo, file)
    .then(() => {
      getDownloadURL(nombreArchivo)
        .then((url) => {
          const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}`);
          const docRefTorneo = doc(firestore, `TorneosTemporales/${idTorneo}`);
          try {
            updateDoc(docRef, {urlProgramacion: url});
            updateDoc(docRefTorneo, {urlProgramacion: url});
            toast.success('La programación ha sido cargada con éxito.');
          } catch (error) {
            toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
          }
        })
        .catch(() => {
          toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
        });
    })
    .catch(() => {
      toast.error('¡Ups! Ocurrio un error. Intentalo de nuevo.');
    });
}

/* La funcion eliminar nos ayudara a borrar las fotos y archivos del usuario, pero antes debera reutenticarse
para poder eliminar. */
export async function traerArchivos(setArchivos) {
  const archivos = ref(storage);
  const auxArchivos = [];

  try {
    const item = await listAll(archivos);
    for (const i of item.items) {
      const downloadURL = await getDownloadURL(i);
      auxArchivos.push({
        name: i.name, // Nombre del archivo
        url: downloadURL, // URL del archivo
        ruta: i.fullPath,
      });
    }

    setArchivos(auxArchivos);
  } catch (error) {
    console.error("Error al listar archivos:", error);
  }
}

//funcion para elminar foto de curso
export function eliminarArchivo(file) {
  const nombreFoto = ref(storage, `${file}`);
  deleteObject(nombreFoto)
    .then(() => {
      toast.success("El archivo se ha sido eliminado con éxito.");
    })
    .catch(() => {
      toast.error(
        "Se produjo un error al eliminar el archivo, inténtalo de nuevo."
      );
    });
}

//------------------- fin configuracion de fotos y documentos ---------------
// -------------------- configuracion cierre de inscripciones ---------------------

export function cerrarInscripcionesTorneo(id, inscripcionesCerradas, cerradoManual){
  const docRef = doc(firestore, `TorneosTemporales/${id}`);
  try {
    updateDoc(docRef, {inscripcionesCerradas});
    if(cerradoManual){
      toast.success(inscripcionesCerradas ? 'Inscripciones cerradas correctamente.' : 'Inscripciones abierta correctamente.');
    }
  } catch (error) {
    toast.error('UPS! Ocurrio un error. Intentalo de nuevo.');
  }
}

// -------------------- fin configuracion cierre de inscripciones ---------------------
// -------------------- configuracion reinicio torneo -------------------------
export async function reinicioTotalTorneo(id){
  eliminarBaseDeDatosLocal(id);
  const docuRef = doc(firestore, `TorneosTemporales/${id}`);
  const subColeccionClubes = collection(docuRef, 'clubes');
  const subColeccionPlanilla = collection(docuRef, 'planilla');
  const subColeccionTiempos = collection(docuRef, 'tiempos');
  const subColeccionMensajes = collection(docuRef, 'mensajes');
  const docSnapClubes = await getDocs(subColeccionClubes);
  const docSnapPlanilla = await getDocs(subColeccionPlanilla);
  const docSnapTiempos = await getDocs(subColeccionTiempos);
  const docSnapMensajes = await getDocs(subColeccionMensajes);

  try {
    docSnapClubes.forEach(async (sub)=>{
      if(sub.exists()){
        await deleteDoc(sub.ref);
      }
    })
    docSnapPlanilla.forEach(async (sub)=>{
      if(sub.exists()){
        await deleteDoc(sub.ref);
      }
    })
    docSnapTiempos.forEach(async (sub)=>{
      if(sub.exists()){
        await deleteDoc(sub.ref);
      }
    })
    docSnapMensajes.forEach(async (sub)=>{
      if(sub.exists()){
        await deleteDoc(sub.ref);
      }
    })

    reiniciarResultadosFamilia(id);

    toast.success('Reiniciando el torneo..., esto puede tardar unos segundos o minutos.');
  } catch (error) {
    toast.error('UPS! Ocurrio un error. Intentalo de nuevo.');
  }
}
// -------------------- fin configuracion reinicio torneo ------------------------
// ------------------- configuracion inscripciones relevos ----------------
export async function registrarRelevo(id, relevos, idForanea, modo){
  const docuRef = doc(firestore, `TorneosTemporales/${id}`, `clubes/${idForanea}`);
  updateDoc(docuRef, {relevos}).then(() =>{
    if(modo === 'registrar'){
      toast('El relevo se ha registrado correctamente.',{
        icon: '🏊🏊‍♀️'
      });
    }else{
      toast('El relevo se ha eliminado correctamente.',{
        icon: '🏊🏊‍♀️'
      });
    }
  }).catch(() =>{
    toast.error('UPS!! Ocurrio un error, intentalo de nuevo o comunicate con el administrador de la pagina.');
  })
}

export async function traerRelevos(idTorneo, setNadadoresRelevo){
  if(idTorneo !== ''){
    const docRef = collection(firestore, `TorneosTemporales/${idTorneo}/clubes`);
    const docSnap = await getDocs(docRef);
    const nadadoresRelevo = [];
    const auxNadadoresRelevo = docSnap.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data().relevos);
    auxNadadoresRelevo.forEach((auxNad)=>{
      auxNad.forEach((nad)=>{
        nadadoresRelevo.push(nad);
      })
    })
    setNadadoresRelevo(nadadoresRelevo);
  }
}

export async function traerPlanillaRelevos(id, idPlanilla){
  if(id !== ''){
    const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${idPlanilla}`);
    const docSnap = await getDoc(docRef);
    let auxPlanilla;
    if(docSnap.exists()){
      auxPlanilla = docSnap.data();
    }
    return auxPlanilla;
  }
}

export async function registrarPlanillaRelevos(id, idPlanilla, planilla){
  if(id !== ''){
    const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${idPlanilla}`);
    const docSnap = await getDoc(docRef);
    if(docSnap.exists()){
      updateDoc(docRef, {planilla: planilla.planilla}).then(()=>{
        toast.success("Relevo registrado correctamente.");
      })
    }else{
      setDoc(docRef, {id: parseInt(idPlanilla), planilla: planilla.planilla}).then(()=>{
        toast.success("Relevo registrado correctamente.");
      })
    }
  }
}
// ------------------- fin configuracion inscripciones relevos ----------------
// -------------------  configuracion inscripciones PSC(Pruebas, Series, Carriles) ----------------
export async function traerPlanillaPSC(id, idPlanilla){
  if(id !== ''){
    const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${idPlanilla}`);
    const docSnap = await getDoc(docRef);
    let auxPlanilla;
    if(docSnap.exists()){
      auxPlanilla = docSnap.data();
    }
    return auxPlanilla;
  }
}

export async function registrarPlanillaPSC(id, idPlanilla, planilla){
  if(id !== ''){
    const docRef = doc(firestore, `TorneosTemporales/${id}/planilla/${idPlanilla}`);
    const docSnap = await getDoc(docRef);
    if(docSnap.exists()){
      updateDoc(docRef, {planilla: planilla.planilla}).then(()=>{
        toast.success(`Prueba ${idPlanilla} actualizada correctamente.`);
      })
    }
  }
}
// ------------------- fin configuracion inscripciones PSC(Pruebas, Series, Carriles) ----------------
//----------------------- configuracion enviar y validar datos a prowebsports --------------
async function validarActivacionPlataforma(nombreclub){
  const docuRef = doc(firestoreRankingPws, `clientes/${nombreclub}`);
  const docSnap = await getDoc(docuRef);
  return docSnap.data().pf;
}

export async function edicionesDelTorneo(idTorneo, nombreclub, ediccion){
  const docuRef = doc(firestoreRankingPws, `clientes/${nombreclub}`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const torneoEditado = docSnap.data().torneos.filter((torn)=>{return torn.id === idTorneo});
    torneoEditado[0].titulo = ediccion.titulo;
    torneoEditado[0].fecha = ediccion.fechaTorneo;
    torneoEditado[0].fechaF = ediccion.fechaTorneoF;
    torneoEditado[0].publicidad = ediccion.publicidad;
    torneoEditado[0].fechaInscripciones = ediccion.fechaInscripciones;
    torneoEditado[0].carril = ediccion.carril;
    torneoEditado[0].valorClub = ediccion.valorClub;
    torneoEditado[0].valorDeportista = ediccion.valorDeportista;
    torneoEditado[0].direccion = ediccion.direccion;
    torneoEditado[0].convocatoria = ediccion.convocatoria;
    torneoEditado[0].image = ediccion.image;
    torneoEditado[0].ciudad = ediccion.ciudad;
    torneoEditado[0].piscina = ediccion.piscina; 
    torneoEditado[0].cronometros = ediccion.cronometros;
    torneoEditado[0].puntuacion = ediccion.puntuacion;
    torneoEditado[0].plataforma = ediccion.plataforma;
    torneoEditado[0].digitador = ediccion.digitador;
    torneoEditado[0].cronos = ediccion.cronos;
    torneoEditado[0].privacidad = ediccion.privacidad;
    if(ediccion.urlResultados){
      torneoEditado[0].urlResultados = ediccion.urlResultados;
    }
    const torneosNoEditados = docSnap.data().torneos.filter((torn)=>{return torn.id !== idTorneo});
    const auxTorneos = [...torneoEditado, ...torneosNoEditados];
    updateDoc(docuRef, {torneos: auxTorneos});
  }
}

export async function torneoRegistradoPWS(torneo) {
  const auxTorneo = {
    id: torneo.id,
    titulo: torneo.titulo,
    fecha: torneo.fechaTorneo,
    fechaF: torneo.fechaTorneoF,
    publicidad: torneo.publicidad,
    fechaInscripciones: torneo.fechaInscripciones,
    carril: torneo.carril,
    valorClub: torneo.valorClub,
    valorDeportista: torneo.valorDeportista,
    direccion: torneo.direccion,
    convocatoria: torneo.convocatoria,
    image: torneo.image,
    ciudad: torneo.ciudad,
    piscina: torneo.piscina, 
    cronometros: torneo.cronometros,
    pagado: false,
    deportistas: "0",
    puntuacion: torneo.puntuacion,
    plataforma: torneo.plataforma,
    digitador: torneo.digitador,
    cronos: torneo.cronos,
    urlResultados: torneo.urlResultados,
    privacidad: torneo.privacidad
  }

  const docuRef = doc(firestoreRankingPws, `clientes/${datosAdmin.conexion}`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const torneosGuardados = [...docSnap.data().torneos, auxTorneo];
    updateDoc(docuRef, {torneos: torneosGuardados});
  }
}

export async function deportistaRegistradoPWS(club, idTorneo) {
  const clubMinus = club.toLowerCase();
  let nombreclub = '';
  if (clubMinus.indexOf(' ') !== -1) {
    nombreclub = clubMinus.replace(/ /g, "-");
  } else {
    nombreclub = clubMinus;
  }
  const docuRef = doc(firestoreRankingPws, `clientes/${nombreclub}`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const auxTorneoGuardados = docSnap.data().torneos.filter((tor)=>{return tor.id !== idTorneo});
    const auxTorneoActual = docSnap.data().torneos.filter((tor)=>{return tor.id === idTorneo});
    auxTorneoActual[0].deportistas = (parseInt(auxTorneoActual[0].deportistas) + 1) + "";
    const torneos = [...auxTorneoGuardados, ...auxTorneoActual];

    updateDoc(docuRef, {torneos});
  }
}

async function deportistaRegistradoFinalesPWS(club, idTorneo, cantDeport) {
  const clubMinus = club.toLowerCase();
  let nombreclub = '';
  if (clubMinus.indexOf(' ') !== -1) {
    nombreclub = clubMinus.replace(/ /g, "-");
  } else {
    nombreclub = clubMinus;
  }
  const docuRef = doc(firestoreRankingPws, `clientes/${nombreclub}`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const auxTorneoGuardados = docSnap.data().torneos.filter((tor)=>{return tor.id !== idTorneo});
    const auxTorneoActual = docSnap.data().torneos.filter((tor)=>{return tor.id === idTorneo});
    auxTorneoActual[0].deportistas = (parseInt(auxTorneoActual[0].deportistas) + cantDeport) + "";
    const torneos = [...auxTorneoGuardados, ...auxTorneoActual];

    updateDoc(docuRef, {torneos});
  }
}

export async function deportistaEliminadoPWS(club, idTorneo) {
  const clubMinus = club.toLowerCase();
  let nombreclub = '';
  if (clubMinus.indexOf(' ') !== -1) {
    nombreclub = clubMinus.replace(/ /g, "-");
  } else {
    nombreclub = clubMinus;
  }
  const docuRef = doc(firestoreRankingPws, `clientes/${nombreclub}`);
  const docSnap = await getDoc(docuRef);
  if(docSnap.exists()){
    const auxTorneoGuardados = docSnap.data().torneos.filter((tor)=>{return tor.id !== idTorneo});
    const auxTorneoActual = docSnap.data().torneos.filter((tor)=>{return tor.id === idTorneo});
    auxTorneoActual[0].deportistas = (parseInt(auxTorneoActual[0].deportistas) - 1) + "";
    const torneos = [...auxTorneoGuardados, ...auxTorneoActual];

    updateDoc(docuRef, {torneos});
  }
}

//----------------------- fin configuracion enviar y validar datos a prowebsports --------------
//---------------------- configuracion eventos finales ----------------------
let unsubscriboFinales = null;

export function traerFinales(idFinales, setFinales) {
  unsubscriboFinales = onSnapshot(doc(firestore, `TorneosTemporales/${idFinales}`), (docc) => {
    const auxTorneo = docc.data();
    setFinales(auxTorneo);
  });
}

// Función para cancelar la suscripción
export function cancelarSuscripcionFinales() {
  if (unsubscriboFinales) {
    unsubscriboFinales();
    unsubscriboFinales = null;
  }
}

function sacarCategoriaInscita(listPruebas, pruebasId, edadRegistrada, sexo){ 
  let auxCategoria = new Set();
  pruebasId.forEach((idsPrue)=>{
    const auxListPruebas = listPruebas.filter((listPrue)=>{return listPrue.id === idsPrue});
    if(auxListPruebas.length !== 0){
      auxListPruebas.forEach((lisPrue)=>{
        const relevo = lisPrue.prueba.match(/Relevo/g);
        if(!relevo){
          lisPrue.requisitos.forEach((req)=>{
            if(req.genero === 'Mixto'){
              if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada){
                auxCategoria.add(lisPrue.categoria);
              }
            }else{
              if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada && req.genero === sexo){
                auxCategoria.add(lisPrue.categoria);
              }
            }
          })
        }
      })
    }
  })
  return Array.from(auxCategoria);
}

export function sacarEdadDeLaCategoria(categoria, edadRegistrada, listadoCategorias, listPruebas, pruebasId){
  let categoriaAsignada = `${edadRegistrada}`;
  categoria.forEach((cate)=>{
    const auxCategoria = listadoCategorias.filter((listCate)=>{return listCate.valor === cate});
    const auxPrueba = listPruebas.filter((listPrue)=>{return listPrue.categoria === cate});
    if(auxPrueba.length !== 0){
      pruebasId.forEach((prueId)=>{
        const auxPruebaId = auxPrueba.filter((auxPrue)=>{return auxPrue.id === prueId});
        if(auxPruebaId.length !== 0){
          auxPruebaId[0].requisitos.forEach((req)=>{
            if(parseInt(req.edadInicio) <= edadRegistrada && parseInt(req.edadFin) >= edadRegistrada){
              if(auxCategoria[0].premiacion === 'separados'){
                if(auxCategoria[0].grupos.length !== 0){
                  const auxGrupo = auxCategoria[0].grupos.filter((gru)=>{return parseInt(gru.edadInicio) <= edadRegistrada && parseInt(gru.edadFin) >= edadRegistrada});
                  if(auxGrupo.length !== 0){
                    categoriaAsignada = `${auxGrupo[0].edadInicio === auxGrupo[0].edadFin ? auxGrupo[0].edadInicio : (auxGrupo[0].edadFin === "999" ? auxGrupo[0].edadInicio + ' y Mas' : auxGrupo[0].edadInicio + ' - ' + auxGrupo[0].edadFin)}`;
                  }
                }else{
                  categoriaAsignada = `${req.edadInicio === req.edadFin ? req.edadInicio : (req.edadFin === "999" ? req.edadInicio + ' y Mas' : req.edadInicio + ' - ' + req.edadFin)}`;
                }
              }else{
                categoriaAsignada = `${req.edadInicio === req.edadFin ? req.edadInicio : (req.edadFin === "999" ? req.edadInicio + ' y Mas' : req.edadInicio + ' - ' + req.edadFin)}`;
              }
            }
          })
        } 
      })
    }
  })
  return categoriaAsignada;
}

function sacarClasificados(prueba, finales){
  let pruebaConMMinimas;
  const auxClasificados = {};
  finales.forEach((jor)=>{
    pruebaConMMinimas = jor.pruebas.filter((prue)=>{return prue.prueba === prueba.prueba.prueba})[0];
  })

  prueba.nadadores.forEach((nad)=>{
    const auxObjNad = {
      nombreclub: nad.nombreclub,
      identificacion: nad.identificacion,
      pruebas: [pruebaConMMinimas.idPrueba],
      records: [{
        prueba: pruebaConMMinimas.idPrueba,
        record: nad.tiempo
      }]
    }

    const nombreclub = nad.nombreclub;
    if (!auxClasificados[nombreclub]) {
        auxClasificados[nombreclub] = [];
    }
    auxClasificados[nombreclub].push(auxObjNad);
  })

  return auxClasificados;
}

async function sacarIdClub(idTorneo, prueba, finales, listadoCategorias, listPruebas){
  const torneo = doc(firestore, `TorneosTemporales/${idTorneo}`);
  const clubes = collection(torneo, 'clubes');
  const auxObjClubes = sacarClasificados(prueba, finales);
  const auxClubes = [];
  for(let nombreclub in auxObjClubes){
    const auxNadadores = [];
    const consultaTorneo = query(clubes, where("nombreclub", '==', `${nombreclub}`));
    const queryClubes = await getDocs(consultaTorneo);
    const auxClub = queryClubes.docs.filter((club)=> club.exists).map((club)=> club.data());
    auxObjClubes[nombreclub].forEach((club)=>{
      const auxNadador = auxClub[0].nadadores.filter((nad)=>{return nad.identificacion === club.identificacion})[0];
      auxNadador.pruebas = club.pruebas;
      auxNadador.records = club.records;
      auxNadador.categoria = sacarEdadDeLaCategoria(sacarCategoriaInscita(listPruebas, auxNadador.pruebas, auxNadador.edad, auxNadador.genero), auxNadador.edad, listadoCategorias, listPruebas, auxNadador.pruebas);
      auxNadadores.push(auxNadador);
    })
    auxClub[0].nadadores = auxNadadores;
    auxClubes.push(auxClub[0]);
  }
  return auxClubes;
}

export async function registrarClasificados(idTorneo, idFinales, prueba, finales, listadoCategorias, listPruebas){
  const auxClubes = await sacarIdClub(idTorneo, prueba, finales, listadoCategorias, listPruebas);
  auxClubes.forEach(async(club)=>{
    const docuRef = doc(firestore, `TorneosTemporales/${idFinales}/clubes/${club.idClub}`);
    const docSnap = await getDoc(docuRef);
    if(docSnap.exists()){
      const nadadoresGuardados = docSnap.data().nadadores;
      const auxNadadoresClasificados = [];

      const auxNadadoresGuardados = nadadoresGuardados.filter(nadB => !club.nadadores.some(nad => nadB.identificacion === nad.identificacion));
      auxNadadoresClasificados.push(...auxNadadoresGuardados);

      club.nadadores.forEach((nad)=>{
        const auxNadadores = nadadoresGuardados.filter((nadB)=>{return nadB.identificacion === nad.identificacion})[0];
        if(auxNadadores){
          nad.records.forEach((prue)=>{
            const auxRecords = auxNadadores.records.filter((prueB)=>{return prueB.prueba !== prue.prueba});
            if(auxRecords.length !== 0){
              const idsPruebas = [];

              auxRecords.forEach((auxR)=>{
                idsPruebas.push(auxR.prueba);
              })

              nad.pruebas = [...idsPruebas, ...nad.pruebas];
              nad.records = [...auxRecords, ...nad.records];
            }
          })

          auxNadadoresClasificados.push(nad);
        }else{
          auxNadadoresClasificados.push(nad);
        }
      })

      if(auxNadadoresClasificados.length !== 0){
        updateDoc(docuRef, {nadadores: auxNadadoresClasificados}).then(() =>{
          let auxCantDeport = 0;
          club.nadadores.forEach((nad)=>{
            const auxNadadores = nadadoresGuardados.filter((nadB)=>{return nadB.identificacion === nad.identificacion});
            if(auxNadadores.length === 0){
              auxCantDeport++;
            }
          })
          deportistaRegistradoFinalesPWS(datosAdmin.conexion, idFinales, auxCantDeport);
        });
      }
    }else{
      setDoc(docuRef, club).then(() =>{
        deportistaRegistradoFinalesPWS(datosAdmin.conexion, idFinales, club.nadadores.length);
      });
    }
  })
}

//---------------------- fin configuracion eventos finales ----------------------
//---------------------- configuracion categorias firebase ----------------------
export async function registrarCategoria(categorias){
  const docRef = doc(firestore, `categorias/lWXRreZYu66eC6rgzy6r`);
  const docSnap = await getDoc(docRef)
  if(!docSnap.exists()){
    setDoc(docRef, {categorias});
    toast.success('Categorias registradas correctamente.');
  }else{
    updateDoc(docRef, {categorias});
    toast.success('Categorias Actualizadas correctamente.');
  }
}

let unsubscribeCategoria = null;
export async function traerListadoCategoria(setListadoCategorias){
  const docRef = collection(firestore, `categorias`);
  unsubscribeCategoria = onSnapshot(docRef, (querySnapshot) => {
    const resultados = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data())

      setListadoCategorias(resultados[0].categorias);
  });
}

export function cancelarCategoria(){
  if (unsubscribeCategoria) {
    unsubscribeCategoria();
    unsubscribeCategoria = null;
  }
}
//---------------------- fin configuracion categorias firebase ------------------
//---------------------- configuracion resultados familia ----------------------
//tiempos Registrar
export async function registrarTorneoFamilia(idTorneo, torneoEspecifico){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}`);
  const docSnap = await getDoc(docRef)
  if(!docSnap.exists()){
    setDoc(docRef, {titulo: torneoEspecifico.titulo, fechaTorneoF: torneoEspecifico.fechaTorneoF});
  }else{
    updateDoc(docRef, {titulo: torneoEspecifico.titulo, fechaTorneoF: torneoEspecifico.fechaTorneoF});
  }
}

export async function registrarTiemposFamilia(idTorneo, idTiempo, prueba){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/tiempos/${idTiempo}`);
  const docSnap = await getDoc(docRef)
  if(!docSnap.exists()){
    setDoc(docRef, prueba);
  }else{
    updateDoc(docRef, prueba);
  }
}

//operacion para traer los resultados en tiempo real.
let unsubscribeTiemposFamilia = null;

export async function traerTitulosTorneosFamilia(setTitulosTorneos){
  const tiemposCollectionRef = collection(firestoreFamilia, `${datosAdmin.conexion}`);
  
  unsubscribeTiemposFamilia = onSnapshot(tiemposCollectionRef, (querySnapshot) => {
    const resultados = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => {
        const data = doc.data();
        data.idTorneo = doc.id;
        return data;
      });

      resultados.sort((a, b) => new Date(b.fechaTorneoF) - new Date(a.fechaTorneoF));

      setTitulosTorneos(resultados);
  });
}

export async function traerResultadosFamilia(idTorneo, setResultados){
  const tiemposCollectionRef = collection(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/tiempos`);
  
  unsubscribeTiemposFamilia = onSnapshot(tiemposCollectionRef, (querySnapshot) => {
    const resultados = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data())
      .sort((a, b) => a.id - b.id);

      setResultados(resultados);
  });
}

export function cancelarTiemposResultadosFamilia(){
  if (unsubscribeTiemposFamilia) {
    unsubscribeTiemposFamilia();
    unsubscribeTiemposFamilia = null;
  }
}

export async function reiniciarResultadosFamilia(idTorneo){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}`);
  const subColeccionTiempos = collection(docRef, 'tiempos');
  const docSnapTiempos = await getDocs(subColeccionTiempos);
  docSnapTiempos.forEach(async (sub)=>{
    if(sub.exists()){
      await deleteDoc(sub.ref);
    }
  })
}

export async function traerInformacionTorneoParaFamilias(idTorneo, setNumeroCarriles, setCarrilInicio, setCarrilFin, setPuntuar, setPiscina, setUsoSistemaCronos, setUrlResultados, setUrlProgramacion) {
  const docRef = doc(firestore, `TorneosTemporales/${idTorneo}`);
  const docSnap = await getDoc(docRef);
  if(docSnap.exists()){
    setNumeroCarriles(parseInt(docSnap.data().carril));
    setPuntuar(docSnap.data().puntuacion);
    setPiscina(docSnap.data().piscina);
    setCarrilInicio(parseInt(docSnap.data().carrilInicio));
    setCarrilFin(parseInt(docSnap.data().carrilFin));
    setUsoSistemaCronos(docSnap.data().cronometros === 'si' ? true : false);
    if(docSnap.data().urlResultados){
      setUrlResultados(docSnap.data().urlResultados);
    }
    if(docSnap.data().urlProgramacion){
      setUrlProgramacion(docSnap.data().urlProgramacion);
    }
  }
}
//---------------------- fin configuracion resultados familia ----------------------
//---------------------- configuracion calificaciones y opiniones ----------------------
export async function registrarOpinion(idTorneo, calificacion){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/opiniones/${calificacion.id}`);
  const docSnap = await getDoc(docRef)
  if(!docSnap.exists()){
    setDoc(docRef, calificacion);
  }
}

let unsubscribeOpiniones = null;

export async function traerOpiniones(idTorneo, setOpiniones, setCalificacionGeneral){
  const opinionesCollectionRef = collection(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/opiniones`);
  
  unsubscribeOpiniones = onSnapshot(opinionesCollectionRef, (querySnapshot) => {
    const opiniones = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data())
      .sort((a, b) => {
        const fechaA = new Date(a.fecha);
        const fechaB = new Date(b.fecha);
        return fechaB - fechaA; // Orden descendente (más reciente primero)
      });

    setOpiniones(opiniones);
    const suma = opiniones.reduce((total, calificacion) => total + calificacion.estrellas, 0);
    const promedio = suma / opiniones.length;
    setCalificacionGeneral(promedio.toFixed(1));
  });
}

export function cancelarOpiniones(){
  if (unsubscribeOpiniones) {
    unsubscribeOpiniones();
    unsubscribeOpiniones = null;
  }
}

export function eliminarOpinion(idTorneo, idOpinion){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}/opiniones/${idOpinion}`);
  deleteDoc(docRef);
}
//---------------------- fin configuracion calificaciones y opiniones ------------------
//---------------------- configuracion reacciones ----------------------
export async function registrarVisualizaciones(idTorneo){
  const docRef = doc(firestoreFamilia, `${datosAdmin.conexion}/${idTorneo}`);
  const docSnap = await getDoc(docRef);
  if(docSnap.exists()){
    updateDoc(docRef, {visualizaciones: parseInt(!docSnap.data().visualizaciones ? 1 : docSnap.data().visualizaciones + 1)});
  }
  const docRefTotalVisua = doc(firestoreFamilia, `totalVisualizaciones/pGSY3Xx2gdsEAJamPApD`);
  const docSnapTotalVisua = await getDoc(docRefTotalVisua);
  if(docSnapTotalVisua.exists()){
    updateDoc(docRefTotalVisua, {total: parseInt(!docSnapTotalVisua.data().total ? 1 : docSnapTotalVisua.data().total + 1)});
  }
}

export async function registrarReaccion(reacciones){
  const docRef = doc(firestoreFamilia, `reaccion/reacciones`);
  const docSnap = await getDoc(docRef)
  if(docSnap.exists()){   
    updateDoc(docRef, reacciones);
  }else{
    setDoc(docRef, reacciones);
  }
}

export async function traerReacciones(setReacciones){
  const tiemposCollectionRef = collection(firestoreFamilia, `reaccion`);
  
  onSnapshot(tiemposCollectionRef, (querySnapshot) => {
    const resultados = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data())

      setReacciones(...resultados);
  });
}
//---------------------- fin configuracion reacciones ----------------------
//---------------------- configuracion notificaciones ----------------------
function saludar() {
  const hora = new Date().getHours();

  let saludo;
  if (hora >= 5 && hora < 12) {
    saludo = "Buen día";
  } else if (hora >= 12 && hora < 18) {
    saludo = "Buenas tardes";
  } else {
    saludo = "Buenas noches";
  }

  return `${saludo}. Espero que estés teniendo un excelente día 😊`;
}

export const notificacion = async (token, body, anfitrion) =>{
  // URL de la función de Firebase
  const functionUrl = 'https://sendnotification-6fbfrucvna-uc.a.run.app/sendNotification';

  // Token FCM del dispositivo y detalles de la notificación
  const deviceToken = token.token;
  const notificationTitle = anfitrion;
  const notificationBody = body;
  try {
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: deviceToken,
        title: notificationTitle,
        body: notificationBody,
        image: 'https://firebasestorage.googleapis.com/v0/b/orcas-valle.appspot.com/o/img_logo.png?alt=media&token=3de7af94-afef-4449-9ea0-aa63aa7b46d1',
        plataforma: datosAdmin.plataforma
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || 'Error al enviar notificación');
    }

    return data;
  } catch (error) {
    throw new error;
  }
}

export const requestNotificationPermission = async (usuario) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // Obtener el token de FCM
      let tokenValido = true;
      if(!localStorage.getItem('idNotificacion')){
        const token = await getToken(messaging, { vapidKey: "BGCcYZV4qjRot9baYQEnke2hGxckV2ajaw1FRrS1Mel1baUP53JtYOIVO-ahjGMwtFg4-KsjLVHf2s1xmND-QR4" });
        notificacion({token: token}, saludar(), usuario.nombreclub).then(() =>{
          if (token) {
            consultarTokenNotificacion(token).then((tk)=>{
              if(!tk){
                guardarTokenNotificacion(token, usuario.nombreclub);
              }
            })
          }
          localStorage.setItem('idNotificacion', token);
        }).catch(() =>{
          eliminarTokenNotificacion(token);
          tokenValido = false;
        });
      }else{
        notificacion({token: localStorage.getItem('idNotificacion')}, saludar(), usuario.nombreclub).then(() =>{
          consultarTokenNotificacion(localStorage.getItem('idNotificacion')).then((tk)=>{
            if(!tk){
              guardarTokenNotificacion(localStorage.getItem('idNotificacion'), usuario.nombreclub);
            }
          });
        }).catch(() =>{
          tokenValido = false;
          if(localStorage.getItem('idNotificacion')){
            eliminarTokenNotificacion(localStorage.getItem('idNotificacion'));
            localStorage.removeItem('idNotificacion');
          }
        });
      }

      while(!tokenValido){
        const token = await getToken(messaging, { vapidKey: "BGCcYZV4qjRot9baYQEnke2hGxckV2ajaw1FRrS1Mel1baUP53JtYOIVO-ahjGMwtFg4-KsjLVHf2s1xmND-QR4" });
        notificacion({token: token}, saludar(), usuario.nombreclub).then(() =>{
          if (token) {
            guardarTokenNotificacion(token, usuario.nombreclub);
          }
          localStorage.setItem('idNotificacion', token);
          tokenValido = true;
        }).catch(() =>{
          tokenValido = false;
        });
      }
    }else{
      if(localStorage.getItem('idNotificacion')){
        localStorage.removeItem('idNotificacion');
      }
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
  }
};

async function guardarTokenNotificacion(token, equipo) {
  const docRef = doc(firestore, `notificaciones/${generarId()}`);
  const docSnap = await getDoc(docRef);
  if(!docSnap.exists()){
    setDoc(docRef, {token, equipo});
  }
}

async function consultarTokenNotificacion(token) {
  const docRef = collection(firestore, `notificaciones`);
  const queryTokens = query(docRef, where("token", "==", `${token}`));
  const getTokens = await getDocs(queryTokens);
  return getTokens.docs[0] ? true : false;
}

export async function eliminarTokenNotificacion(token) {
  const docRef = collection(firestore, `notificaciones`);
  const queryTokens = query(docRef, where("token", "==", `${token}`));
  const getTokens = await getDocs(queryTokens);
  getTokens.docs.forEach((tk)=>{
    const docTokenRef = doc(firestore, `notificaciones/${tk.id}`);
    deleteDoc(docTokenRef);
  })
}

export async function traerTokensNotificacionInscripciones() {
  const docRef = collection(firestore, `notificaciones`);
  const docSnap = await getDocs(docRef);
  const auxTokens = [];
  docSnap.forEach((token)=>{
    auxTokens.push(token.data());
  })
  return auxTokens;
}

async function traerTokensNotificaciones() {
  const docRef1 = collection(firestoreRankingPws, `notifiTorneos`);
  const docRef2 = collection(firestore, `notificaciones`);
  const docSnap1 = await getDocs(docRef1);
  const docSnap2 = await getDocs(docRef2);
  const auxTokens = [];
  docSnap1.forEach((docc)=>{
    auxTokens.push(docc.data());
  })
  docSnap2.forEach((token)=>{
    auxTokens.push(token.data());
  })
  return auxTokens;
}

onMessage(messaging, (payload) => {
  const { title, body, image, plataforma } = payload.data;
  const auxTituloBody = body.split('•');
  if(auxTituloBody[1]){
    const alerta = Swal.mixin({
      confirmButtonText: "¡Quiero Participar!",
      confirmButtonColor: 'rgb(40, 167, 69)',
      showCancelButton: true,
      cancelButtonText: 'Salir'
    })
    alerta.fire({
      title,
      html: `<p class="text-start"><b>${auxTituloBody[0]}</b><br/>
      ${auxTituloBody[1]}<br/>
      ${auxTituloBody[2]}<br/>
      ${auxTituloBody[3]}<br/>
      ${auxTituloBody[4]}<br/>
      ${auxTituloBody[5]}<br/>
      ${auxTituloBody[6]}<br/>
      ${auxTituloBody[7]}<br/>
      ${auxTituloBody[8]}<br/>
      ${auxTituloBody[9]}</p>`
    }).then((result)=>{
      if(result.isConfirmed){
        window.open(plataforma, '_blank');
      }
    })
  }else{
    const alerta = Swal.mixin({
      toast: true,
      timer: '5000',
      timerProgressBar: true,
      showConfirmButton: false
    })
    alerta.fire({
      title,
      html: `<div class="w-100 position-relative">
      <img style="width: 50px; position: absolute; top: 0; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
      <p style="z-index: 10; font-family: Poppins" class="mb-0">${body}</div>`,
      position: 'top-end',
      padding: 2
    })
  }
});
//---------------------- fin configuracion notificaciones ----------------------
//---------------------- configuracion info usuarios de prowebsports ----------------------
export async function registrarUsuarioPws(datosUsuario){
  const docRef = doc(firestoreRankingPws, `usuarios/${datosUsuario.id}`);
  setDoc(docRef, {
    nombreclub: datosUsuario.nombreclub,
    abreviatura: datosUsuario.abreviatura,
    departamento: datosUsuario.departamento,
    email: datosUsuario.email,
    codePais: datosUsuario.codePais
  });
}

export async function registrarDirectivosPws(datosUsuario, directivos){
  const docRef = doc(firestoreRankingPws, `usuarios/${datosUsuario.id}`);
  updateDoc(docRef, { directivos });
}

export async function traerUsuariosPws(datosUsuario){
  const docRef = doc(firestoreRankingPws, `usuarios/${datosUsuario.id}`);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data() : null;
}
//---------------------- fin configuracion info usuarios de prowebsports ------------------
// ------------------ configuracion para records Mundiales y Nacionales ----------------------
export async function traerRecords(setRecords, ambito, piscina){
  const recordsMN = collection(firestoreRankingPws, `recordsMN`);
  const queryRecordsMN = query(recordsMN, where("ambito", "==", `${ambito}`), where("piscina", "==", `${piscina}`)); 
  const docRecordsMN = await getDocs(queryRecordsMN);
  const auxRecordsMN = [];
  docRecordsMN.forEach((docc)=>{
    auxRecordsMN.push(docc.data());
  })
  setRecords(auxRecordsMN);
}
// ------------------ fin configuracion para records Mundiales y Nacionales ----------------------
// ------------------ configuracion para enviar correos ----------------------
export const sendEmailDocumento = async (pdfBase64, asunto, text, emails, nombreArchivo) => {
  const url = "https://sendemaildocumento-6fbfrucvna-uc.a.run.app/sendEmailDocumento";

  const payload = {
    emails: emails,
    subject: asunto,   
    text: text, 
    pdfBase64: pdfBase64,
    fileName: nombreArchivo
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    if (response.ok) {
      console.log("Correo enviado exitosamente:", data);
    } else {
      console.error("Error al enviar el correo:", data);
    }
  } catch (error) {
    console.error("Error en la solicitud:", error);
  }
};

export const sendEmail = async (asunto, text, emails) => {
  const url = "https://sendgmail-6fbfrucvna-uc.a.run.app/sendGmail";

  const payload = {
    emails: emails,
    subject: asunto,   
    text: text,
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    if (response.ok) {
      console.log("Correo enviado exitosamente:", data);
    } else {
      console.error("Error al enviar el correo:", data);
    }
  } catch (error) {
    console.error("Error en la solicitud:", error);
  }
};
// ------------------ fin configuracion para enviar correos ----------------------
//---------------------- configuracion cronometros ----------------------
// Función para registrar datos
export function registrarCronometro(id, datosCronometro) {
  // Referencia a la ubicación específica en Realtime Database
  const cronometroRef = refDatabase(database, `carril${id}`);

  // Establece los datos en la ubicación especificada
  set(cronometroRef, datosCronometro)
  .then(() => {
    console.log('Datos registrados correctamente en Firebase');
  })
  .catch((error) => {
    console.error('Error registrando datos en Firebase:', error);
  });
}

export function traerEstadosCronometros(setDatosCronometros){
  const starCountRef = refDatabase(database, `/`);
  onValue(starCountRef, (snapshot) => {
    const data = snapshot.val();
    if(data !== null){
      setDatosCronometros(data);
    }
  });
}
//---------------------- fin configuracion cronometros ----------------------
//----------------------  configuracion fotos deportistas ----------------------
export const resizeImage = (img, maxSize) => {
  const canvas = document.createElement('canvas');
  let { width, height } = img;

  if (width > height) {
    if (width > maxSize) {
      height *= maxSize / width;
      width = maxSize;
    }
  } else {
    if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }
  }

  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);
  return canvas;
};

function subirUrlAlRanking(ti, url){
  const docRef = doc(firestoreRankingPws, `ranking/${ti}`);
  updateDoc(docRef, {urlPhoto: url});
}

export function subirFoto(blob, ti) {
  const img = new Image();
  img.src = URL.createObjectURL(blob);

  img.onload = () => {
    const canvas = resizeImage(img, 400);
    canvas.toBlob(async (blob400) => {

      const nombreFoto = ref(storagePws, `fotosDeportistas/${ti}.webp`);
      uploadBytes(nombreFoto, blob400)
        .then(() => {
          toast.success("La foto del deportista ha sido cargada con éxito.");
          getDownloadURL(nombreFoto).then((url) => {
            subirUrlAlRanking(ti, url);
          });
        })
        .catch(() => {
          toast.error(
            "¡¡ups!! Se produjo un error al cargar la foto, intente nuevamente o cargue otra foto."
          );
        });
    }, "image/webp", 1.0)
  }
}

export function eliminarFoto(ti){
  const desertRef = ref(storagePws, `fotosDeportistas/${ti}.webp`); 
  deleteObject(desertRef).then(() => {
    const url = '';
    subirUrlAlRanking(ti, url);
    toast.success('Foto eliminada correctamente.');
  }).catch((error) => {
    toast.success('Ups!! Ocurrio un error al eliminar la foto.');
  });
}
//---------------------- fin configuracion fotos deportistas ----------------------
//---------------------- configuracion records evento ----------------------
export const registrarRecordEvento = async (programacion, prueba, torneoEspecifico, recordsEvento, fecha) => {
  const serieActual = Math.max(...prueba.nadadores.map(nad => parseInt(nad.serie)));
  const auxPruebaValida = pruebasEstablecidasRanking().filter((prue) => prue === prueba.prueba.prueba);
  if(serieActual >= programacion[prueba.id].length && auxPruebaValida.length !== 0){
    const revisarTiempo = prueba.nadadores[0]?.tiempo ? prueba.nadadores[0].tiempo : (prueba.nadadores[0].tiempoMin + ':' + prueba.nadadores[0].tiempoSeg + ':' + prueba.nadadores[0].tiempoMili); 
    if(!prueba.nadadores[0].equipo && (revisarTiempo !== '0:0:0' && revisarTiempo !== '61:0:0')){ 
      const deportista = prueba.nadadores[0];
      const arreglarFecha = new Date(fecha);
      const fechaArreglada = arreglarFecha.toLocaleString('es-ES',{ 
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
      const auxPrueba = {
        id: generarId(),
        prueba: prueba.prueba.prueba,
        piscina: torneoEspecifico.piscina,
        deportista: deportista.nombre,
        edad: deportista.edad,
        identificacion: deportista.identificacion,
        verificado: deportista.verificado,
        club: deportista.nombreclub,
        record: revisarTiempo,
        fecha: fechaArreglada, 
        genero: deportista.genero,
        evento: torneoEspecifico.titulo,
        codePais: deportista.codePais,
        departamento: deportista.departamento,
        urlPhoto: deportista.urlPhoto,
        recordAnterior: null
      }
      const buscarRecord = recordsEvento.filter((rec) => rec.piscina === torneoEspecifico.piscina && rec.genero === deportista.genero && rec.prueba === prueba.prueba.prueba);
      if(buscarRecord.length !== 0){
        const dividirTiempoA = buscarRecord[0].record.split(':');
        const dividirTiempoB = auxPrueba.record.split(':');
        const tiempoMinA = dividirTiempoA[0];
        const tiempoSegA = dividirTiempoA[1];
        const tiempoMiliA = dividirTiempoA[2];
        const tiempoMinB = dividirTiempoB[0];
        const tiempoSegB = dividirTiempoB[1];
        const tiempoMiliB = dividirTiempoB[2];
        const tiempoA = parseInt(tiempoMinA) * 60 * 1000 + parseInt(tiempoSegA) * 1000 + parseInt(tiempoMiliA);
        const tiempoB = parseInt(tiempoMinB) * 60 * 1000 + parseInt(tiempoSegB) * 1000 + parseInt(tiempoMiliB);
        
        if(tiempoA > tiempoB){
          const docRef = doc(firestore, `recordsEvento/${buscarRecord[0].id}`);
          auxPrueba.id = buscarRecord[0].id;
          if(buscarRecord[0].fecha !== auxPrueba.fecha){
            auxPrueba.recordAnterior = buscarRecord[0];
          }
          updateDoc(docRef, auxPrueba).catch((err)=> console.log(err)); 
        }
      }else{
        const docRef = doc(firestore, `recordsEvento/${auxPrueba.id}`);
        setDoc(docRef, auxPrueba).catch((err)=> console.log(err));
      }
    }
  }
}

let unsubscribeRecordsEvento = null;

export async function traerRecordsEvento(setRecordsEvento){
  const recordsEventoCollectionRef = collection(firestore, `recordsEvento`);
  
  unsubscribeRecordsEvento = onSnapshot(recordsEventoCollectionRef, (querySnapshot) => {
    const auxRecords = querySnapshot.docs
      .filter((doc) => doc.exists)
      .map((doc) => doc.data());

    setRecordsEvento(auxRecords);
  });
}

export function cancelarRecordsEvento(){
  if (unsubscribeRecordsEvento) {
    unsubscribeRecordsEvento();
    unsubscribeRecordsEvento = null;
  }
}
//---------------------- fin configuracion records evento ----------------------
//---------------------- configuracion sesion familia ----------------------
export async function crearCuentaFamilia(email, password, nombre) {
  try {
    createUserWithEmailAndPassword(authFamilia, email, password);

    updateProfile(authFamilia.currentUser, {
      displayName: nombre
    }).catch(() => {
      toast.error("Ocurrió un error al registrar su nombre.");
    });
  } catch (err) {
    toast.error("El correo electrónico  " + email + ", ya está registrado.");
  }
}

// iniciar sesion por google para resultados familias
export const loginGoogle = async () => {
  try {
    const infoUsuario = await signInWithPopup(authFamilia, providerGoogle);
    registrarUsuarioFamilia({
      nombre: infoUsuario.user.displayName,
      id: infoUsuario.user.uid,
      photo: infoUsuario.user.photoURL,
      email: infoUsuario.user.email,
    });
  } catch (error) {
    console.error("Error al iniciar sesión con Google:", error);
  }
};

export const loginGoogleAutomatico = async (response) => {
  try {
    const credential = GoogleAuthProvider.credential(response.credential);
    await signInWithCredential(authFamilia, credential);
  } catch (error) {
    console.error("Error al iniciar sesión con Google:", error);
  }
};

export const sesionIniciadaFamilia = (setUsuarioFamilia) =>{
  onAuthStateChanged(authFamilia, (usuarioFirebase) => {
    if(usuarioFirebase){
      const datosUsuario = {
        nombre: authFamilia.currentUser.displayName,
        id: usuarioFirebase.uid,
        photo: authFamilia.currentUser.photoURL,
        email: authFamilia.currentUser.email
      }

      setUsuarioFamilia(datosUsuario);
    }else{
      setUsuarioFamilia();
    }
  })
}

export const cerrarSesionFamilia = () =>{
  signOut(authFamilia);
}

export const registrarUsuarioFamilia = async (datosUsuario) => {
  const docRef = doc(firestoreFamilia, `usuarios/${datosUsuario.id}`);
  const docSnap = await getDoc(docRef);
  if(!docSnap.exists()){
    setDoc(docRef, datosUsuario).catch((err)=> console.log(err)); 
  }
}

let unsubscribeInfoFamilia = null;
export const traerInformacionUsuarioFamilia = (id, setInfoFamilia) =>{
  const docRef = doc(firestoreFamilia, `usuarios/${id}`);
  unsubscribeInfoFamilia = onSnapshot(docRef, (docSnap) => {
    if(docSnap.exists()){
      setInfoFamilia(docSnap.data());
    }
  });
}

export function cancelarInfoFamilia(){
  if (unsubscribeInfoFamilia) {
    unsubscribeInfoFamilia();
    unsubscribeInfoFamilia = null;
  }
}

export const traerInformacionActualUsuarioFamilia = async (idUser) =>{
  const docRef = doc(firestoreFamilia, `usuarios/${idUser}`);
  const docSnap = await getDoc(docRef);
  return docSnap.data();
}

export const traerInformacionPagoFamilia = async (idUser, idEvento) =>{
  const docRef = collection(firestoreFamilia, `usuarios/${idUser}/pagos`);
  const queryPago = query(docRef, where("idEvento", "==", `${idEvento}`)); 
  const docSnap = await getDocs(queryPago);
  return !docSnap.docs[0] ? docSnap.docs[0] : docSnap.docs[0].data();
}
//---------------------- fin configuracion sesion familia ----------------------